import React from 'react';
import moment from 'moment';
import {
  Typography,
  Box,
  Grid,
  Avatar,
  Chip,
  Paper,
  makeStyles,
  Card,
  CardContent,
  IconButton,
  Button,
  Tooltip,
  ButtonBase,
  CircularProgress,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Divider,
  Dialog,
  DialogContent,
  Toolbar,
  AppBar,
  DialogActions,
} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import DynamicIcon from 'components/Common/DynamicIcon';
import { useDropzone } from 'react-dropzone';
import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles,
} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import { get } from 'lodash';

import { DynamicView } from '..';
import { textFormatter } from 'util/string';
import SMDialogControl from 'services/SMDialogControl';
import SMDIalogControl from 'services/SMDialogControl';
import TextField from '@material-ui/core/TextField';
import { CloseOutlined, EditOutlined } from '@material-ui/icons';
import Timeline from '@material-ui/lab/Timeline';
import TimelineItem from '@material-ui/lab/TimelineItem';
import TimelineSeparator from '@material-ui/lab/TimelineSeparator';
import TimelineConnector from '@material-ui/lab/TimelineConnector';
import TimelineContent from '@material-ui/lab/TimelineContent';
import TimelineDot from '@material-ui/lab/TimelineDot';
import TimelineOppositeContent from '@material-ui/lab/TimelineOppositeContent';
import FormGroup from './FormGroups';
import { FormControl } from 'util/FormControl';
import {
  EditableDropdownWidget,
  InputWithIncrementDecrement,
  SearchAndAddWidget,
} from './FormWidgets';
import { Skeleton } from '@material-ui/lab';
import SMConfirmDialogControl from 'services/SMDialogControl';
import { configure, GlobalHotKeys } from 'react-hotkeys';
import { preventDefaultHandlers } from 'util/misc';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { useHistory } from 'react-router';
import { sendAnalyticsEvent } from 'analytics/analytics';

export const useStyles = makeStyles((theme) => ({
  chip: {
    minWidth: 24,
    maxWidth: '100%',
  },
  boxGridContent: {
    margin: theme.spacing(1),
    width: 120,
    height: 120,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  box: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    padding: theme.spacing(2),
    justifyContent: 'center',
    alignItems: 'center',
  },
  singleBox: {
    minWidth: 300,
    minHeight: 320,
    diplay: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    background: '#ffffff',
    boxShadow: '0px 2.5px 20px #0000002d',
    borderRadius: '10px',
  },
  rowBoxes: {
    display: 'flex',
    margin: theme.spacing(-1),
  },
  rowBox: {
    flex: 1,
    borderTop: '1px solid #c2c2c2',
    borderRight: '1px solid #c2c2c2',
    textAlign: 'center',
  },
  name: {
    fontSize: 14,
    color: '#707070',
  },
  value: {
    fontSize: 14,
    fontWeight: 700,
    color: '#616161',
  },
  gradientCard: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: '0px 2.5px 20px #0000002d',
    borderRadius: 7,
    opacity: '1',
    minWidth: '275px',
    height: '100px', //ToDo - Make width and height responsive
  },
  gradientCardContent: {
    paddingLeft: 50,
  },
  gradientCardTitle: {
    textAlign: 'left',
    letterSpacing: '0px',
    fontWeight: 'bolder',
    color: '#898989',
  },
  gradientCardSubtitle: {
    paddingTop: 5,
    textAlign: 'left',
    letterSpacing: '0px',
    color: '#505050',
    fontWeight: 'bolder',
  },
  gradientIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '8%',
    height: '100%',
    borderTopRightRadius: 7,
    borderBottomRightRadius: 7,
  },
  progressActionBox: {
    width: '15vw',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  whiteCardPlate: {
    width: '100%',
    minHeight: '89px',
    boxShadow: '0px 2.5px 20px #0000002d',
    borderRadius: '10px',
    opacity: 1,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '20px',
    backgroundColor: '#ffffff',
  },
  iconButton: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  tooltip: {
    fontSize: 12,
  },
  orderDetails: {
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    fontSize: '13px',
    wordWrap: 'nowrap',
    marginRight: 20,
  },
  addtoCartButton: {
    marginLeft: 10,
    background: `transparent linear-gradient(2deg, 
            '#2896E9' 0%, '#7467F0' 100%) 0% 0% no-repeat padding-box`,
    color: '#ffffff',
    paddingLeft: 18,
    paddingRight: 18,
    height: 40,
    maxWidth: 250,
    borderRadius: 5,
  },
  addtoCartButtonDisabled: {
    marginLeft: 10,
    background: '#33C17D !important',
    color: '#ffffff',
    paddingLeft: 10,
    paddingRight: 10,
    height: 40,
    maxWidth: 250,
    borderRadius: 5,
  },
  infoCard: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: '0px 2.5px 20px #f0f4f5',
    borderRadius: 10,
    opacity: '1',
    minWidth: '275px',
    height: '100px', //ToDo - Make width and height responsive
  },
  infoCardContent: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 50,
  },
  infoCardTitle: {
    textAlign: 'left',
    letterSpacing: '0px',
    fontWeight: 'bolder',
    color: '#898989',
  },
  infoCardSubtitle: {
    paddingTop: 0,
    textAlign: 'left',
    letterSpacing: '0px',
    color: '#505050',
    fontWeight: 'bolder',
  },
  titleContainer: {
    position: 'sticky',
    top: 0,
    background: '#f9f9fc',
    display: 'flex',
    alignItems: 'center',
    paddingTop: 8,
    marginRight: theme.spacing(3),
    marginLeft: theme.spacing(3),
  },
  title: {
    // marginLeft: theme.spacing(4),
    fontSize: 28,
    flexGrow: 1,
    fontWeight: 'bold',
  },
  button: {
    marginLeft: theme.spacing(2),
    paddingLeft: 10,
    paddingRight: 10,
    height: 40,
    maxWidth: 250,
    borderRadius: 5,
  },
  buttonIcon: {
    height: 20,
    width: 20,
    color: '#ffffff',
    fontSize: 15,
  },
  buttonText: {
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    marginLeft: 5,
    marginRight: 10,
    color: '#ffffff',
  },
  popper: {
    zIndex: theme.zIndex.modal,
  },
  tableRow: {
    hover: {
      '&$hover:hover': {
        backgroundColor: '#49bb7b',
      },
    },
  },
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  imageList: {
    flexWrap: 'nowrap',
    transform: 'translateZ(0)',
  },
  imagetitle: {
    color: '#ffffff',
  },
  titleBar: {
    background:
      'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
  dialogTitlebar: {
    background: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    backgroundColor: '#ffffff',
    boxShadow: 'none',
    borderBottom: '1px solid #e5e5e5',
  },
  dialogTitle: {
    paddingLeft: theme.spacing(1.5),
  },
  dialogActions: {
    margin: theme.spacing(0, 3),
    padding: theme.spacing(2, 0),
    borderTop: '1px solid #b5b5b5',
  },
  carouselContainer: {
    // '&::-webkit-scrollbar': {
    //   height: 0,
    //   width: 0,
    // },
  },
  paper: {
    padding: '6px 16px',
  },
}));

export function HeadingWidget({ heading, text, border, subHeading, ...props }) {
  const classes = useStyles();
  const {
    deep_link,
    apiType,
    handleDeeplink,
    setDeepLink,
    overrideHandleDeepLink,
    actions,
    setMessage,
  } = props;
  heading = heading || props.title;
  subHeading = subHeading || props.subtitle;
  const [anchorEl, setAnchorEl] = React.useState(null);
  // console.log(deep_link, (overrideHandleDeepLink ? setDeepLink : handleDeeplink))

  return (
    <Tooltip
      title={!!anchorEl ? '' : heading}
      classes={{
        tooltip: classes.tooltip,
      }}
      disableFocusListener={!heading}
      disableHoverListener={!heading}
      disableTouchListener={!heading}
    >
      <Box
        p={1}
        className={classes.whiteCardPlate}
        style={{
          flexDirection: 'column',
          width: '15vw',
          border: `1px solid ${border}`,
          borderRadius: 7.5,
          cursor: deep_link ? 'pointer' : undefined,
          borderLeft: `5px solid ${props.barColor || '#7467F0'}`,
          padding: 20,
          marginTop: 15,
          cursor: !!deep_link ? 'pointer' : undefined,
        }}
        onClick={() => {
          deep_link &&
            sendAnalyticsEvent('Heading widget clicked', {
              deep_link: deep_link,
              apiType: apiType,
            });
          deep_link &&
            (overrideHandleDeepLink || !apiType || apiType === 1
              ? setDeepLink
              : handleDeeplink)(deep_link, apiType, props, {
              fallbackOperation: setDeepLink,
              doneCallback: (refreshDeeplink) => {
                setDeepLink(refreshDeeplink);
                SMDialogControl.close();
                SMConfirmDialogControl.close();
              },
              errorCallback: (error) => {},
            });
        }}
      >
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              maxWidth: (actions && '80%') || '95%',
            }}
          >
            {heading && (
              <Typography
                variant="h6"
                style={{
                  fontSize: '17px',
                  color: '#161616',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  maxWidth: '100%',
                  fontSize: '16px',
                  fontWeight: 'bold',
                  textTransform: 'uppercase',
                }}
              >
                {heading}
              </Typography>
            )}
            {subHeading && (
              <Typography
                variant="subtitle1"
                style={{
                  textOverflow: 'ellipsis',
                  maxWidth: '100%',
                  fontSize: '16px',
                  fontSize: '12px',
                  textTransform: 'uppercase',
                  wordWrap: 'nowrap',
                }}
              >
                {subHeading}
              </Typography>
            )}
            {text && (
              <Typography
                variant="h6"
                style={{
                  fontSize: '15px',
                  letterSpacing: '0px',
                  color: '#767676',
                  opacity: 1,
                  fontSize: '14px',
                  fontWeight: 'bold',
                }}
              >
                {text}
              </Typography>
            )}
          </div>
          {actions && (
            <div>
              <IconButton
                onClick={(event) => {
                  event.stopPropagation();
                  setAnchorEl(event.currentTarget);
                }}
              >
                <DynamicIcon iconId={933} />
              </IconButton>
              <Menu
                style={{
                  transform: 'translateX(-16px) translateY(40px)',
                }}
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={(event) => {
                  event.stopPropagation();
                  setAnchorEl(null);
                }}
              >
                {actions.map((action) => (
                  <MenuItem
                    style={{
                      display: 'flex',
                    }}
                    onClick={(event) => {
                      event.stopPropagation();
                      action.isCopyAction
                        ? navigator.clipboard.writeText(action.copyText)
                        : action.deep_link &&
                          handleDeeplink(
                            action.deep_link,
                            action.apiType || 1,
                            props,
                            {
                              fallbackOperation: setDeepLink,
                              doneCallback: (refreshDeeplink) => {
                                setDeepLink(refreshDeeplink);
                                SMDialogControl.close();
                                SMConfirmDialogControl.close();
                              },
                              errorCallback: (error) => {},
                            }
                          ).then((response) => {
                            if (response) {
                              response.refreshDeeplink &&
                                setDeepLink(response.refreshDeeplink);
                              response.userMessage &&
                                setMessage(response.userMessage);
                            }
                          });
                      setAnchorEl(null);
                    }}
                  >
                    <DynamicIcon
                      style={{
                        height: 20,
                        width: 20,
                        fontSize: 15,
                        marginRight: 10,
                      }}
                      iconId={action.iconId}
                    />
                    <div
                      style={{
                        whiteSpace: 'nowrap',
                        marginLeft: 5,
                        marginRight: 15,
                        fontSize: 16,
                      }}
                    >
                      {action.title}
                    </div>
                  </MenuItem>
                ))}
              </Menu>
            </div>
          )}
        </div>
      </Box>
    </Tooltip>
  );
}

export function KeyValueWidget({ _key, value, iconId, text, ...props }) {
  const {
    deep_link,
    handleDeeplink,
    setDeepLink,
    apiType,
    overrideHandleDeepLink,
  } = props;
  value = value || text;

  return (
    <Box
      p={1}
      onClick={() =>
        deep_link &&
        (overrideHandleDeepLink || !apiType || apiType === 1
          ? setDeepLink
          : handleDeeplink)(deep_link, apiType, props, {
          fallbackOperation: setDeepLink,
          doneCallback: (refreshDeeplink) => {
            setDeepLink(refreshDeeplink);
            SMDialogControl.close();
            SMConfirmDialogControl.close();
          },
          errorCallback: (error) => {},
        })
      }
    >
      <Grid container>
        {iconId && (
          <Grid item xs={1}>
            <Box display="flex" alignItems="center" justifyContent="center">
              <DynamicIcon iconId={iconId} />
            </Box>
          </Grid>
        )}
        <Grid item xs={iconId ? 5 : 6}>
          <Box> {_key}</Box>
        </Grid>
        <Grid item xs>
          <Box fontWeight="fontWeightBold"> {value} </Box>
        </Grid>
      </Grid>
    </Box>
  );
}

export function DescriptionWidget({
  title,
  subtitle,
  index,
  iconId,
  desc,
  text,
  ...props
}) {
  const {
    deep_link,
    handleDeeplink,
    setDeepLink,
    apiType,
    overrideHandleDeepLink,
  } = props;
  desc = desc || text;

  return (
    <Box
      style={{
        border: '1px solid #dddddd',
        margin: 10,
        display: 'flex',
        alignItems: 'center',
        padding: 20,
        cursor: !!deep_link ? 'pointer' : undefined,
      }}
      onClick={() =>
        deep_link &&
        (overrideHandleDeepLink || !apiType || apiType === 1
          ? setDeepLink
          : handleDeeplink)(deep_link, apiType, props, {
          fallbackOperation: setDeepLink,
          doneCallback: (refreshDeeplink) => {
            setDeepLink(refreshDeeplink);
            SMDialogControl.close();
            SMConfirmDialogControl.close();
          },
          errorCallback: (error) => {},
        })
      }
    >
      {iconId && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            width: 30,
            marginRight: 5,
          }}
        >
          <DynamicIcon iconId={iconId} style={{ width: 25, height: 25 }} />
        </div>
      )}
      <div>
        <Typography style={{ fontSize: 17.5, fontWeight: 'bold' }}>
          {index ? `${index}. ` : ''}
          {title}
        </Typography>
        {subtitle && <Typography variant="subtitle2">{subtitle}</Typography>}
        {desc && <Typography variant="body2">{desc}</Typography>}
      </div>
    </Box>
  );
}

export function TimeIconWidget({ time_epoch, iconId, ...props }) {
  return (
    <DescriptionWidget
      title={moment.unix(time_epoch).format('DD MMM YYYY | hh:mm a')}
      iconId={iconId}
      {...props}
    />
  );
}

export function StateWidget({ title, subtitle, state, time_epoch, ...props }) {
  const classes = useStyles();
  const {
    deep_link,
    handleDeeplink,
    setDeepLink,
    apiType,
    overrideHandleDeepLink,
  } = props;

  return (
    <Box
      p={1}
      onClick={() =>
        deep_link &&
        (overrideHandleDeepLink || !apiType || apiType === 1
          ? setDeepLink
          : handleDeeplink)(deep_link, apiType, props, {
          fallbackOperation: setDeepLink,
          doneCallback: (refreshDeeplink) => {
            setDeepLink(refreshDeeplink);
            SMDialogControl.close();
            SMConfirmDialogControl.close();
          },
          errorCallback: (error) => {},
        })
      }
      style={{
        border: '1px solid #dddddd',
        marginTop: 15,
        display: 'flex',
        alignItems: 'center',
        padding: 20,
        flexDirection: 'column',
      }}
    >
      <Grid container>
        <Grid item xs={state ? 9 : 12}>
          <Typography variant="h6" noWrap={true}>
            {title}
          </Typography>{' '}
        </Grid>
        {state && (
          <Grid item xs={3}>
            <Box textAlign="right">
              {' '}
              <Chip
                size="small"
                color="primary"
                label={state}
                className={classes.chip}
              />{' '}
            </Box>
          </Grid>
        )}
      </Grid>
      <Grid container>
        <Grid item xs={time_epoch ? 8 : 12}>
          {' '}
          <Typography variant="subtitle2">{subtitle}</Typography>{' '}
        </Grid>
        {time_epoch && (
          <Grid item xs={4}>
            <Box textAlign="right">
              {' '}
              <Typography variant="subtitle2">
                {' '}
                {moment.unix(time_epoch).fromNow()}{' '}
              </Typography>{' '}
            </Box>
          </Grid>
        )}
      </Grid>
    </Box>
  );
}

export function AvatarWidget({
  title,
  subtitle,
  avatar,
  counter,
  time_epoch,
  ...props
}) {
  const classes = useStyles();
  const {
    deep_link,
    handleDeeplink,
    setDeepLink,
    apiType,
    overrideHandleDeepLink,
  } = props;

  return (
    <Box
      p={1}
      onClick={() =>
        deep_link &&
        (overrideHandleDeepLink || !apiType || apiType === 1
          ? setDeepLink
          : handleDeeplink)(deep_link, apiType, props, {
          fallbackOperation: setDeepLink,
          doneCallback: (refreshDeeplink) => {
            setDeepLink(refreshDeeplink);
            SMDialogControl.close();
            SMConfirmDialogControl.close();
          },
          errorCallback: (error) => {},
        })
      }
      className={classes.whiteCardPlate}
      style={{ marginTop: 15, cursor: !!deep_link ? 'pointer' : undefined }}
    >
      <Grid container alignItems="center">
        <Grid item xs={2}>
          <Box display="flex" alignItems="center" justifyContent="center">
            <Avatar src={avatar} />
          </Box>
        </Grid>
        <Grid item xs={10}>
          <Grid container>
            <Grid item xs={counter ? 9 : 12}>
              {' '}
              <Typography variant="h6">{title}</Typography>{' '}
            </Grid>
            {counter && (
              <Grid item xs={3}>
                <Box textAlign="right">
                  {' '}
                  <Chip
                    size="small"
                    color="primary"
                    label={counter}
                    className={classes.chip}
                  />{' '}
                </Box>
              </Grid>
            )}
          </Grid>
          {(subtitle || time_epoch) && (
            <Grid container>
              <Grid item xs={time_epoch ? 8 : 12}>
                {' '}
                <Typography variant="subtitle2">{subtitle}</Typography>{' '}
              </Grid>
              {time_epoch && (
                <Grid item xs={4}>
                  <Box textAlign="right">
                    {' '}
                    <Typography variant="subtitle2">
                      {' '}
                      {moment.unix(time_epoch).fromNow()}{' '}
                    </Typography>{' '}
                  </Box>
                </Grid>
              )}
            </Grid>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}

export function StatesWidget({ title, state, ...props }) {
  const {
    deep_link,
    handleDeeplink,
    setDeepLink,
    apiType,
    overrideHandleDeepLink,
  } = props;
  const classes = useStyles();

  return (
    <Box
      p={1}
      onClick={() =>
        deep_link &&
        (overrideHandleDeepLink || !apiType || apiType === 1
          ? setDeepLink
          : handleDeeplink)(deep_link, apiType, props, {
          fallbackOperation: setDeepLink,
          doneCallback: (refreshDeeplink) => {
            setDeepLink(refreshDeeplink);
            SMDialogControl.close();
            SMConfirmDialogControl.close();
          },
          errorCallback: (error) => {},
        })
      }
      style={{
        border: '1px solid #dddddd',
        marginTop: 15,
        display: 'flex',
        alignItems: 'center',
        padding: 20,
        flexDirection: 'column',
      }}
    >
      <Typography variant="h6">{title}</Typography>
      <Grid container>
        {state &&
          state.map(
            (
              {
                title,
                current,
                'color-on': color_on,
                'color-off': color_off,
                deep_link,
              },
              index
            ) => {
              return (
                <Grid item xs={3} key={index}>
                  <Box
                    borderRadius={17.5}
                    m="auto"
                    width={35}
                    height={35}
                    style={{
                      background: current ? color_on : color_off,
                    }}
                  />
                  <Typography style={{ fontSize: '0.8rem' }} align="center">
                    {title}
                  </Typography>
                </Grid>
              );
            }
          )}
      </Grid>
    </Box>
  );
}

export function BoxWidget({ title, subtitle, color, subtitleColor, ...props }) {
  const styles = useStyles();
  const {
    deep_link,
    handleDeeplink,
    setDeepLink,
    apiType,
    overrideHandleDeepLink,
  } = props;

  return (
    <Box
      className={styles.box}
      onClick={() =>
        deep_link &&
        (overrideHandleDeepLink || !apiType || apiType === 1
          ? setDeepLink
          : handleDeeplink)(deep_link, apiType, props, {
          fallbackOperation: setDeepLink,
          doneCallback: (refreshDeeplink) => {
            setDeepLink(refreshDeeplink);
            SMDialogControl.close();
            SMConfirmDialogControl.close();
          },
          errorCallback: (error) => {},
        })
      }
    >
      <Typography
        variant="h2"
        align="center"
        style={{ color, fontSize: '16px', fontWeight: 'bold' }}
      >
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="h6"
          align="center"
          style={{ color: subtitleColor, fontSize: '14px', fontWeight: 'bold' }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
}

export function BoxRowsWidget(data) {
  const styles = useStyles();
  const {
    deep_link,
    handleDeeplink,
    setDeepLink,
    apiType,
    overrideHandleDeepLink,
  } = data;

  return (
    <Box
      className={styles.rowBoxes}
      onClick={() =>
        deep_link &&
        (overrideHandleDeepLink || !apiType || apiType === 1
          ? setDeepLink
          : handleDeeplink)(deep_link, data)
      }
    >
      <Box className={styles.rowBox}>
        <Typography className={styles.name}>{data.label1}</Typography>
        <Typography className={styles.value}>{data.value1}</Typography>
      </Box>
      <Box className={styles.rowBox}>
        <Typography className={styles.name}>{data.label2}</Typography>
        <Typography className={styles.value}>{data.value2}</Typography>
      </Box>
      <Box className={styles.rowBox} style={{ borderRight: 'none' }}>
        <Typography className={styles.name}>{data.label3}</Typography>
        <Typography className={styles.value}>{data.value3}</Typography>
      </Box>
    </Box>
  );
}

export function FourBoxWidget({ handleDeeplink, ...props }) {
  const BoxGrid = ({ item }) => {
    return (
      <Grid item xs={12} md={6} style={{ padding: 10 }}>
        <Paper>
          <BoxWidget {...item} />
        </Paper>
      </Grid>
    );
  };
  const item = (num) => ({
    subtitle: props[`label${num}`],
    deep_link: props[`deep_link${num}`],
    title: props[`value${num}`],
    color: props[`textColour${num}`],
  });

  return (
    <Grid container>
      {props['label1'] && <BoxGrid item={item(1)} />}
      {props['label2'] && <BoxGrid item={item(2)} />}
      {props['label3'] && <BoxGrid item={item(3)} />}
      {props['label4'] && <BoxGrid item={item(4)} />}
    </Grid>
  );
}

export function FileWidget({ url, comment, handleDeeplink }) {
  const classes = useStyles();
  return (
    <ButtonBase
      className={classes.whiteCardPlate}
      style={{
        marginTop: 15,
        alignItems: 'center',
        justifyContent: 'flex-start',
      }}
      onClick={() => handleDeeplink(url)}
    >
      <img
        alt=""
        src={url}
        style={{
          objectFit: 'cover',
          height: 100,
          width: 100,
          borderRadius: 7,
        }}
        onClick={() => {}}
      />
      <Typography style={{ margin: 15 }}>{comment}</Typography>
    </ButtonBase>
  );
  // TODO: complete this
}

export function AttendanceWidget({ event, date, eventTime, ...props }) {
  const {
    deep_link,
    handleDeeplink,
    setDeepLink,
    apiType,
    overrideHandleDeepLink,
  } = props;

  return (
    <Box
      p={1}
      onClick={() =>
        deep_link &&
        (overrideHandleDeepLink || !apiType || apiType === 1
          ? setDeepLink
          : handleDeeplink)(deep_link, apiType, props, {
          fallbackOperation: setDeepLink,
          doneCallback: (refreshDeeplink) => {
            setDeepLink(refreshDeeplink);
            SMDialogControl.close();
            SMConfirmDialogControl.close();
          },
          errorCallback: (error) => {},
        })
      }
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h6">
          {moment.unix(date).format('DD MMM YYYY')}
        </Typography>
        <Box>
          <Typography>{event}</Typography>
        </Box>
        <Box>
          <Typography>{moment.unix(eventTime).format('hh:mm a')}</Typography>
        </Box>
      </Box>
    </Box>
  );
}

export function Attendance2EventsWidget({
  date,
  event1,
  event2,
  event1Time,
  event2Time,
  extraDaysVisible,
  extraDaysColor,
  ...props
}) {
  const checkinDate = moment.unix(event1Time);
  const checkoutDate = moment.unix(event2Time);

  const {
    deep_link,
    handleDeeplink,
    setDeepLink,
    apiType,
    overrideHandleDeepLink,
  } = props;

  return (
    <Box
      p={1}
      onClick={() =>
        deep_link &&
        (overrideHandleDeepLink || !apiType || apiType === 1
          ? setDeepLink
          : handleDeeplink)(deep_link, apiType, props, {
          fallbackOperation: setDeepLink,
          doneCallback: (refreshDeeplink) => {
            setDeepLink(refreshDeeplink);
            SMDialogControl.close();
            SMConfirmDialogControl.close();
          },
          errorCallback: (error) => {},
        })
      }
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="h6">
          {moment.unix(date).format('DD MMM YYYY')}
        </Typography>
        <Box>
          <Typography>{event1}</Typography>
          <Typography>{event2}</Typography>
        </Box>
        <Box>
          <Typography>{checkinDate.format('hh:mm a')}</Typography>
          <Typography>{checkoutDate.format('hh:mm a')}</Typography>
        </Box>
      </Box>
      {extraDaysVisible && (
        <Typography
          align="right"
          style={{ fontSize: 14, color: extraDaysColor }}
        >
          +{checkoutDate.diff(checkinDate, 'days')} days
        </Typography>
      )}
    </Box>
  );
}

const gradients = {
  1: 'transparent linear-gradient(180deg, #7467F0 0%, #2896E9 100%) 0% 0% no-repeat padding-box',
  2: 'transparent linear-gradient(180deg, #BC2A13 0%, #2896E9 100%) 0% 0% no-repeat padding-box',
  3: 'transparent linear-gradient(180deg, #1ED2AC 0%, #2896E9 100%) 0% 0% no-repeat padding-box',
  4: 'transparent linear-gradient(180deg, #1ED2AC 0%, #2896E9 100%) 0% 0% no-repeat padding-box',
  5: 'transparent linear-gradient(180deg, #BC2A13 0%, #7467F0 100%) 0% 0% no-repeat padding-box',
  6: 'transparent linear-gradient(180deg, #2896E9 0%, #7467F0 100%) 0% 0% no-repeat padding-box',
  7: 'transparent linear-gradient(116deg, #1ED2AC 0%, #2896E9 100%) 0% 0% no-repeat padding-box',
};

export function getGradient(gradientId) {
  return gradients[gradientId];
}

export const getindexGradientId = (index) => {
  const numberOfGradients = Object.keys(gradients || {}).length;
  return index + 1 > numberOfGradients
    ? (index % numberOfGradients) + 1
    : index + 1;
};

export function GradientCardWidget({ title, subtitle, ...props }) {
  const styles = useStyles();
  const {
    deep_link,
    handleDeeplink,
    setDeepLink,
    apiType,
    overrideHandleDeepLink,
    current,
    selected,
  } = props;
  return (
    <Box
      p={1}
      onClick={() =>
        deep_link &&
        (overrideHandleDeepLink || !apiType || apiType === 1
          ? setDeepLink
          : handleDeeplink)(deep_link, apiType, props, {
          fallbackOperation: setDeepLink,
          doneCallback: (refreshDeeplink) => {
            setDeepLink(refreshDeeplink);
            SMDialogControl.close();
            SMConfirmDialogControl.close();
          },
          errorCallback: (error) => {},
        })
      }
    >
      <Grid container spacing={5}>
        <Grid item xs={3}>
          <Card
            className={styles.gradientCard}
            style={
              current != undefined &&
              selected != undefined &&
              current == selected
                ? { border: '1px solid #1ED2AC', borderWidth: '1px 0 1px 1px' }
                : {}
            }
          >
            <CardContent className={styles.gradientCardContent}>
              <div>
                <Typography
                  className={styles.gradientCardTitle}
                  gutterBottom
                  variant="h4"
                  style={{ fontSize: '25px', fontWeight: 'bold', marginTop: 5 }}
                >
                  {title}
                </Typography>
                <Typography
                  className={styles.gradientCardSubtitle}
                  style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    marginBottom: 5,
                  }}
                >
                  {subtitle}
                </Typography>
              </div>
            </CardContent>
            <div
              className={styles.gradientIcon}
              style={{
                background:
                  current != undefined &&
                  selected != undefined &&
                  current == selected
                    ? `${getGradient(3)}`
                    : `${getGradient(props.gradientId)}`,
              }}
            >
              {props.iconId !== undefined && (
                <DynamicIcon
                  insideColoredButton
                  iconId={props.iconId}
                  style={{ marginBottom: 0.5 }}
                />
              )}
            </div>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

export function InfoWithIconCardWidget({ title, subtitle, ...props }) {
  const styles = useStyles();
  return (
    <Box p={1}>
      <Grid container spacing={5}>
        <Grid item xs={3}>
          <Card
            className={styles.infoCard}
            style={{ border: '0.5px solid #c2c3c4' }}
          >
            <CardContent
              className={styles.infoCardContent}
              style={{ paddingLeft: props.iconId && 20 }}
            >
              {props.iconId && (
                <DynamicIcon
                  iconId={props.iconId}
                  style={{
                    height: 45,
                    width: 45,
                    color: '#ffffff',
                    marginRight: 20,
                  }}
                />
              )}
              <div>
                <Typography
                  className={styles.infoCardTitle}
                  gutterBottom
                  variant="h4"
                  style={{
                    fontSize: '20px',
                    fontWeight: 'bolder',
                    marginTop: 0,
                    color: props.titleColor || '#0D2965',
                  }}
                >
                  {title}
                </Typography>
                <Typography
                  className={styles.infoCardSubtitle}
                  style={{
                    fontSize: '14px',
                    fontWeight: 'bold',
                    marginBottom: 0,
                    color: props.subtitleColor || '#898989',
                  }}
                >
                  {subtitle}
                </Typography>
              </div>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

export function ProgressActionHeadingWidget(props) {
  const styles = useStyles();
  const target = props.target || 100;
  const progress = props.progress;

  const {
    deep_link,
    apiType,
    handleDeeplink,
    setDeepLink,
    overrideHandleDeepLink,
  } = props;

  return (
    <div className={styles.progressActionBox}>
      <Box
        className={styles.whiteCardPlate}
        onClick={() =>
          deep_link &&
          (overrideHandleDeepLink ||
            !apiType ||
            apiType === 1 ||
            !apiType ||
            apiType === 1
            ? setDeepLink
            : handleDeeplink)(deep_link, props)
        }
        style={{ cursor: 'pointer', display: 'block' }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ width: '100%' }}>
            <Typography
              style={{
                fontSize: '17px',
                color: '#161616',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                fontSize: '16px',
                fontWeight: 'bold',
                textTransform: 'uppercase',
              }}
            >
              {props.title}
            </Typography>

            {props.subtitle && (
              <Typography
                style={{
                  fontSize: '15px',
                  letterSpacing: '0px',
                  color: '#767676',
                  opacity: 1,
                  fontSize: '14px',
                  fontWeight: 'bold',
                }}
              >
                {props.subtitle}
              </Typography>
            )}
          </div>
          {props.action &&
            props.action.map((item, index) => (
              <IconButton
                disableRipple={true}
                className={styles.iconButton}
                onClick={() => props.handleDeeplink(item.deep_link)}
                style={{ padding: 6 }}
              >
                <DynamicIcon key={index} iconId={item.iconId} />
              </IconButton>
            ))}
        </div>
        {progress !== undefined && (
          <div
            style={{
              width: 'inherit',
              height: '17px',
              display: 'flex',
              marginTop: 10,
            }}
          >
            <div
              style={{
                width: '100%',
                height: '100%',
                background: '#E2E2E2',
                borderRadius: '5px',
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  width: `${(progress / target) * 100}%`,
                  background:
                    'transparent linear-gradient(90deg, #2896E9 0%, #1ED2AC 100%) 0% 0% no-repeat padding-box',
                  height: '100%',
                }}
              />
            </div>
          </div>
        )}
      </Box>
    </div>
  );
}

export function FileUploadWidget(props) {
  const classes = useStyles();
  const {
    deep_link,
    handleDeeplink,
    setDeepLink,
    apiType,
    overrideHandleDeepLink,
  } = props;

  const onDrop = (acceptedFiles) =>
    acceptedFiles.map((file) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onabort = () => console.log('file reading was aborted');
      reader.onerror = () => console.log('file reading has failed');
      reader.onload = () => {
        // Sheet names and sheet can be find here with XLSX
        const b64 = reader.result.replace(/^data:.+;base64,/, '');
        console.log(b64);
        deep_link && handleDeeplink(deep_link, props);
      };
    });

  const { getRootProps, getInputProps } = useDropzone({
    accept: '.xlsx',
    onDrop,
  });

  return (
    <Box
      style={{
        display: 'flex',
        flex: 1,
        flexFlow: 'column wrap',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f0f0f0',
        minHeight: '50vh',
        maxHeight: '60vh',
        borderRadius: '10px',
      }}
      {...getRootProps({ className: 'dropzone' })}
    >
      <input {...getInputProps()} />
      <DynamicIcon iconId={props.iconId} />
      <Typography variant="h5" style={{ padding: '30px', color: '#747474' }}>
        {props.title}
      </Typography>
    </Box>
  );
}

export function ActionButtonsWidget(props) {
  const classes = useStyles();
  return (
    <Card
      className={classes.whiteCardPlate}
      style={{
        padding: 15,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div>
        {!!props.title && (
          <Typography
            variant="h5"
            style={{
              fontWeight: 700,
              color: '#505050',
              lineHeight: 1,
              margin: 5,
              textTransform: 'uppercase',
            }}
          >
            {props.title}
          </Typography>
        )}
        {!!props.subtitle && (
          <Typography style={{ color: '#505050', margin: 5 }}>
            {props.subtitle}
          </Typography>
        )}
      </div>
      <div
        style={{
          display: 'flex',
          flex: 1,
          alignItems: 'center',
        }}
      >
        {props.buttons.map((button) => (
          <Button
            style={{
              border: 'none',
              background:
                'transparent linear-gradient(2deg, #2896E9 0%, #7467F0 100%) 0% 0% no-repeat padding-box',
              color: '#ffffff',
              borderRadius: 5,
              fontSize: 15,
              fontWeight: 'bold',
              paddingLeft: 30,
              paddingRight: 30,
              margin: 5,
            }}
            onClick={() =>
              button.deep_link &&
              (props.overrideHandleDeepLink ||
                !button.apiType ||
                button.apiType === 1
                ? props.setDeepLink
                : props.handleDeeplink)(
                button.deep_link,
                button.apiType,
                props,
                {
                  fallbackOperation: props.setDeepLink,
                  doneCallback: (refreshDeeplink) => {
                    props.setDeepLink(refreshDeeplink);
                    SMDialogControl.close();
                    SMConfirmDialogControl.close();
                  },
                  errorCallback: (error) => {},
                }
              )
            }
          >
            {button.iconId && (
              <DynamicIcon
                insideColoredButton
                iconId={button.iconId}
                style={{ fontSize: 27.5, marginRight: 5 }}
              />
            )}
            {button.title}
          </Button>
        ))}
      </div>
    </Card>
  );
}

const GradientSVG = (props) => {
  let { startColor, endColor, elementId, rotate } = props;

  let gradientTransform = `rotate(${rotate || 90})`;

  return (
    <svg style={{ width: 0, height: 0, visibility: 'hidden' }}>
      <defs>
        <linearGradient id={elementId} gradientTransform={gradientTransform}>
          <stop offset="0%" stopColor={startColor} />
          <stop offset="100%" stopColor={endColor} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const CircularProgressBar = (props) => {
  const { successColors, errorColors, progress, error, target } = props;

  return (
    <>
      <GradientSVG
        startColor={get(errorColors, 'startColor', '#d6d6d6')}
        endColor={get(errorColors, 'endColor', '#d6d6d6')}
        elementId="errorProgress"
        rotate={150}
      />
      <div style={{ width: 30 }}>
        <CircularProgressbarWithChildren
          value={((progress + error) / target) * 100}
          strokeWidth={12}
          styles={{
            path: { stroke: 'url(#errorProgress)' },
          }}
        >
          <CircularProgressbar
            value={(progress / target) * 100}
            strokeWidth={12}
            styles={{
              ...buildStyles({
                trailColor: 'transparent',
              }),
              path: { stroke: 'url(#mainProgress)' },
            }}
          />
        </CircularProgressbarWithChildren>
      </div>
      <GradientSVG
        startColor={get(successColors, 'startColor', '#d6d6d6')}
        endColor={get(successColors, 'endColor', '#d6d6d6')}
        elementId="mainProgress"
      />
    </>
  );
};

export const ModuleRowWidget = (props) => {
  const {
    successColors,
    errorColors,
    handleDeeplink,
    setDeepLink,
    overrideHandleDeepLink,
    index,
  } = props;

  return (
    <Box
      display="flex"
      borderTop={index > 0 ? '1px solid #EAEAEA' : ''}
      minHeight={30}
      flex={1}
    >
      <Box display="flex" alignItems="center" width="20%">
        <Box
          p={0.5}
          mr={2}
          borderRadius={5}
          height="30px"
          style={{
            background:
              props.gradientId &&
              (getGradient(props.gradientId) || 'transparent'),
          }}
        />
        <Box display="flex" alignItems="center">
          <Typography style={{ fontWeight: 700, textTransform: 'uppercase' }}>
            {props.title}
          </Typography>
        </Box>
      </Box>
      <Box
        display="flex"
        width="70%"
        flex={1}
        style={{ overflow: 'auto', marginLeft: 15 }}
      >
        {get(props, 'modules', []).map((entity, index) => (
          <ButtonBase
            key={index}
            display="flex"
            alignItems="center"
            style={{ padding: 10, cursor: 'pointer' }}
            onClick={() =>
              entity.deep_link &&
              (overrideHandleDeepLink || !entity.apiType || entity.apiType === 1
                ? setDeepLink
                : handleDeeplink)(entity.deep_link)
            }
          >
            <Box>
              <CircularProgressBar
                {...{
                  successColors,
                  errorColors,
                  progress: get(entity, 'progress', 0),
                  error: get(entity, 'error', 0),
                  target: get(entity, 'target', 0),
                }}
              />
            </Box>
            <Box flex={1} style={{ cursor: 'pointer' }}>
              <Typography
                style={{
                  wordWrap: 'nowrap',
                  whiteSpace: 'nowrap',
                  color: '#323333',
                  padding: 2,
                  paddingLeft: 10,
                  fontSize: '12px',
                  textTransform: 'uppercase',
                }}
              >
                {get(entity, 'title', '')}
              </Typography>
            </Box>
          </ButtonBase>
        ))}
      </Box>
    </Box>
  );
};

export const ModulesWidget = ({
  title,
  subtitle,
  dynamicJSON,
  deep_link,
  content_deep_link,
  actions,
  setDeepLink,
  overrideHandleDeepLink,
  ...props
}) => {
  return (
    <Box
      p={3}
      style={{
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 10,
        boxShadow: '0px 2.5px 20px #0000002d',
        height: '100%',
        backgroundColor: '#ffffff',
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <Box>
          <Typography
            variant="h5"
            style={{
              color: '#505050',
              lineHeight: 1,
              marginBottom: 10,
              fontWeight: 'bold',
            }}
          >
            {title}
          </Typography>
          <Typography style={{ color: '#505050' }}>{subtitle}</Typography>
        </Box>
        <Box>
          {actions.map((action, index) => (
            <IconButton key={index}>
              <DynamicIcon
                iconId={action.iconId}
                onClick={() => {}}
                style={{ width: 18 }}
              />
            </IconButton>
          ))}
        </Box>
      </Box>
      <DynamicView
        hideToolbar
        json={dynamicJSON || (!!props.tabs ? props : undefined)}
        deeplink={content_deep_link || deep_link}
        setDeepLink={setDeepLink}
        setDeepLink={setDeepLink}
        withoutBase
        setMessage={() => {}}
      />
    </Box>
  );
};

export const EmptyModulesWidget = (props) => {
  const {
    title,
    subtitle,
    actions,
    overrideHandleDeepLink,
    apiType,
    setDeepLink,
    handleDeeplink,
    localSetDeeplink,
  } = props;

  return (
    <Box
      p={3}
      style={{
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 10,
        boxShadow: '0px 2.5px 20px #0000002d',
        height: '100%',
      }}
    >
      <Box>
        <Typography
          variant="h5"
          style={{ fontWeight: 700, color: '#505050', lineHeight: 1 }}
        >
          {title}
        </Typography>
        <Typography style={{ color: '#505050' }}>{subtitle}</Typography>
      </Box>
      <Box display="flex" flex={1} alignItems="center" justifyContent="center">
        {(actions || []).map((action) => (
          <Button
            style={{
              background: getGradient(action.gradientId),
              padding: '24px 32px',
              color: action.color,
              fontSize: 16,
            }}
            onClick={() =>
              action.deep_link &&
              (overrideHandleDeepLink ? setDeepLink : handleDeeplink)(
                action.deep_link,
                action.apiType,
                undefined,
                {
                  fallbackOperation: setDeepLink,
                  doneCallback: (refreshDeeplink) => {
                    setDeepLink(refreshDeeplink);
                    SMDIalogControl.close();
                    SMConfirmDialogControl.close();
                  },
                  errorCallback: (error) => {},
                }
              )
            }
          >
            {action.title}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export function SingleGradientBox(props) {
  const styles = useStyles();

  const { overrideHandleDeepLink, setDeepLink, handleDeeplink } = props;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        height: '32.5vh',
        marginLeft: '',
        marginTop: '10px',
      }}
    >
      {props.values.map((item, index) => (
        <Card
          className={styles.gradientCard}
          style={{ margin: '0 20px 20px 10px', height: '12vh', width: '5vw' }}
          onClick={() => {
            return (
              item.deep_link &&
              (overrideHandleDeepLink ? setDeepLink : handleDeeplink)(
                item.deep_link
              )
            );
          }}
        >
          <CardContent className={styles.gradientCardContent}>
            <Typography className={styles.gradientCardSubtitle} variant="h4">
              {item.value}
            </Typography>
            <Typography className={styles.gradientCardTitle} gutterBottom>
              {item.title}
            </Typography>
          </CardContent>
          <div
            className={styles.gradientIcon}
            style={{ background: `${getGradient(item.gradientId)}` }}
          ></div>
        </Card>
      ))}
    </div>
  );
}

export function HyperlinkWidget({ heading, subHeading, url, ...props }) {
  const { deep_link, handleDeeplink, setDeepLink, overrideHandleDeepLink } =
    props;
  heading = heading || props.title;
  subHeading = subHeading || props.subtitle;

  return (
    <a
      href={url}
      style={{
        textDecoration: 'none',
        color: '#505050',
      }}
    >
      <Box
        p={1}
        onClick={() =>
          deep_link &&
          (overrideHandleDeepLink ? setDeepLink : handleDeeplink)(
            deep_link,
            props
          )
        }
        style={{ cursor: 'pointer' }}
      >
        <Box display="flex" alignItems="center">
          <Typography variant="h6">{textFormatter(heading)}</Typography>
        </Box>
        {subHeading && (
          <Typography variant="subtitle2">
            {textFormatter(subHeading)}
          </Typography>
        )}
      </Box>
    </a>
  );
}

export function PartitionedDisplayWidget({
  blocks,
  border,
  subHeading,
  ...props
}) {
  const classes = useStyles();
  const {
    deep_link,
    apiType,
    handleDeeplink,
    setDeepLink,
    overrideHandleDeepLink,
  } = props;

  return (
    <Box
      style={{
        cursor: deep_link ? 'pointer' : undefined,
        border: '1px solid #dddddd',
        display: 'flex',
        padding: 10,
        justifyContent: 'space-between',
        alignItems: 'flex-end',
        flex: 1,
      }}
      onClick={() =>
        deep_link &&
        (overrideHandleDeepLink || !apiType || apiType === 1
          ? setDeepLink
          : handleDeeplink)(deep_link, apiType, props, {
          fallbackOperation: setDeepLink,
          doneCallback: (refreshDeeplink) => {
            setDeepLink(refreshDeeplink);
            SMDialogControl.close();
            SMConfirmDialogControl.close();
          },
          errorCallback: (error) => {},
        })
      }
    >
      {(blocks || []).map((block, index) => (
        <div
          style={{
            minWidth: 'calc(33% - 20px)',
            borderLeft: index !== 0 ? '1px solid #dddddd' : 'none',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
            flex: 1,
          }}
        >
          <div
            style={{
              color: '#909090',
              fontSize: 30,
            }}
          >
            {block.title}
          </div>
          <div
            style={{
              color: '#505050',
            }}
          >
            {block.subtitle}
          </div>
        </div>
      ))}
    </Box>
  );
}

export function ParagraphWidget({
  heading,
  text,
  border,
  subHeading,
  hideBorder,
  images,
  ...props
}) {
  const classes = useStyles();
  const {
    deep_link,
    apiType,
    handleDeeplink,
    setDeepLink,
    overrideHandleDeepLink,
  } = props;
  heading = heading || props.title;
  subHeading = subHeading || props.subtitle;

  return (
    <Box
      style={{
        fcursor: deep_link ? 'pointer' : undefined,
        border: hideBorder ? 'none' : '1px solid #dddddd',
        cursor: deep_link ? 'pointer' : undefined,
        margin: 10,
        padding: !hideBorder && 20,
      }}
      onClick={() =>
        deep_link &&
        (overrideHandleDeepLink || !apiType || apiType === 1
          ? setDeepLink
          : handleDeeplink)(deep_link, apiType, props, {
          fallbackOperation: setDeepLink,
          doneCallback: (refreshDeeplink) => {
            setDeepLink(refreshDeeplink);
            SMDialogControl.close();
            SMConfirmDialogControl.close();
          },
          errorCallback: (error) => {},
        })
      }
    >
      {heading && (
        <Typography
          variant="h6"
          style={{
            fontWeight: 'bold',
            textOverflow: 'ellipsis',
            maxWidth: 'calc(100% - 20px)',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
          }}
        >
          {heading}
        </Typography>
      )}
      {subHeading && (
        <Typography variant="subtitle1" style={{ color: '#707070' }}>
          {subHeading.split('\n').map((str) => (
            <p style={{ margin: 0, padding: 0 }}>{str}</p>
          ))}
        </Typography>
      )}
      {text && (
        <Typography
          style={{
            wordWrap: 'normal',
            whiteSpace: 'pre-wrap',
            maxWidth: 'calc(100% - 20px)',
            overflow: 'hidden',
            color: '#000000DE',
            fontSize: 17.5,
          }}
        >
          {text}
        </Typography>
      )}
      {images && (
        <ImagesWidget
          defaultPadding={true}
          size={images.size}
          images={images.images}
          title={images.title}
          subtitle={images.subtitle}
        />
      )}
    </Box>
  );
}

export function TimelineBlockCard({
  title,
  text,
  timeEpoch,
  isFirst,
  isLast,
  ...props
}) {
  const classes = useStyles();
  const container = React.useRef({ current: {} });
  const {
    deep_link,
    apiType,
    handleDeeplink,
    setDeepLink,
    overrideHandleDeepLink,
  } = props;

  return (
    <Box
      ref={container}
      style={{
        marginTop: '10px',
        // cursor: deep_link ? 'pointer' : undefined,
        // display: 'flex',
        // alignItems: 'flex-start',
        // borderLeft: '1px solid #dddddd',
        // borderRight: '1px solid #dddddd',
        // ...(isFirst ? { borderTop: '1px solid #dddddd', paddingTop: 20 } : {}),
        // ...(isLast
        //   ? { borderBottom: '1px solid #dddddd', paddingBottom: 10 }
        //   : {}),
      }}
      onClick={() =>
        deep_link &&
        (overrideHandleDeepLink || !apiType || apiType === 1
          ? setDeepLink
          : handleDeeplink)(deep_link, apiType, props, {
          fallbackOperation: setDeepLink,
          doneCallback: (refreshDeeplink) => {
            setDeepLink(refreshDeeplink);
            SMDialogControl.close();
            SMConfirmDialogControl.close();
          },
          errorCallback: (error) => {},
        })
      }
    >
      <Timeline
        position="alternate"
        style={{ margin: 0, padding: 0, width: '100%' }}
      >
        <TimelineItem>
          <TimelineOppositeContent style={{ flex: 0.1, padding: '2px 10px' }}>
            <Typography
              style={{
                fontSize: 16,
                // fontWeight: 'bold',
              }}
            >
              {moment.unix(timeEpoch).format('hh:mm a')}
            </Typography>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot
              variant="outlined"
              color="warning"
              style={{ fontSize: 16 }}
            />
            {!isLast && (
              <TimelineConnector style={{ backgroundColor: '#6f6f6f' }} />
            )}
          </TimelineSeparator>
          <TimelineContent>
            <div
              style={{ flex: 1, padding: '0px 10px 0px 10px', marginTop: -2 }}
            >
              {title && (
                <Typography
                  style={{
                    fontWeight: 'bold',
                    textOverflow: 'ellipsis',
                    maxWidth: 'calc(100% - 20px)',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    fontSize: 19,
                  }}
                >
                  {title}
                </Typography>
              )}
              {text && (
                <Typography
                  style={{
                    fontSize: 16,
                    fontStyle: 'italic',
                  }}
                >
                  {text}
                </Typography>
              )}
            </div>
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    </Box>
  );
}

export function TimelineCard({ statusDeepLink, ...props }) {
  const classes = useStyles();
  const container = React.useRef({ current: {} });
  const {
    deep_link,
    apiType,
    handleDeeplink,
    setDeepLink,
    overrideHandleDeepLink,
  } = props;

  const [timeline, setTimeline] = React.useState(props.timeline);

  const currentIndex =
    timeline &&
    timeline.reduce(
      (previousVal, item, index) => (item.isCurrentState ? index : previousVal),
      -1
    );

  const refreshTimeline = (refreshDeeplink) => {
    handleDeeplink(refreshDeeplink).then((data) => {
      data.timeline && setTimeline(data.timeline);
    });
  };

  React.useEffect(() => {
    if (statusDeepLink) {
      const interval = setInterval(() => {
        handleDeeplink(statusDeepLink)
          .then((data) => {
            data.stopPolling && clearInterval(interval);
            data.refreshDeeplink && refreshTimeline(data.refreshDeeplink);
          })
          .catch(console.log);
      }, 15000);
    }
  }, [statusDeepLink]);
  const onLinkClick = (deeplink, apiType) => {
    deeplink &&
      (props.overrideHandleDeepLink || !apiType || apiType === 1
        ? props.setDeepLink
        : props.handleDeeplink)(deeplink, apiType, props, {
        fallbackOperation: props.setDeepLink,
        doneCallback: (refreshDeeplink) => {
          setDeepLink(refreshDeeplink);
          SMDialogControl.close();
          SMConfirmDialogControl.close();
        },
        errorCallback: (error) => {},
      });
  };

  return (
    <Box
      ref={container}
      style={{
        marginTop: '10px',
      }}
    >
      <Timeline
        align="alternate"
        style={{ margin: 0, padding: 0, width: '100%' }}
      >
        {!!timeline &&
          timeline.map((item, index) => (
            <TimelineItem>
              <TimelineOppositeContent
                style={{
                  height: 70,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: index % 2 === 0 ? 'flex-end' : 'flex-start',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  style={{
                    fontSize: props.isMobile ? 14 : 16,
                    fontWeight: 'bold',
                    color: '#606060',
                  }}
                >
                  {item.timeEpoch &&
                    moment.unix(item.timeEpoch).format('hh:mm a')}
                </Typography>
              </TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot
                  color={item.isCurrentState ? 'primary' : undefined}
                  style={{
                    padding: 12,
                  }}
                >
                  {item.iconId && (
                    <DynamicIcon
                      iconId={item.iconId}
                      style={{ color: '#ffffff' }}
                    />
                  )}
                </TimelineDot>
                {index < timeline.length - 1 && (
                  <TimelineConnector
                    style={{
                      backgroundColor: index < currentIndex && '#6f6f6f',
                      padding: '22px 0px',
                    }}
                  />
                )}
              </TimelineSeparator>
              <TimelineContent
                style={{
                  height: 70,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: index % 2 === 0 ? 'flex-start' : 'flex-end',
                  justifyContent: 'center',
                }}
              >
                {item.title && (
                  <Typography
                    color={index <= currentIndex ? 'primary' : undefined}
                    style={{
                      fontWeight: 'bold',
                      fontSize: props.isMobile ? 17 : 19,
                      color: index > currentIndex && '#c7c7c7',
                    }}
                  >
                    {item.title}
                  </Typography>
                )}
                {item.text && (
                  <Typography
                    style={{
                      fontSize: props.isMobile ? 14 : 16,
                      color: index > currentIndex && '#c7c7c7',
                    }}
                  >
                    {item.text}
                  </Typography>
                )}
                {item.link && (
                  <Button
                    color="primary"
                    onClick={() =>
                      onLinkClick(item.link.deep_link, item.link.apiType)
                    }
                    style={{ padding: 0 }}
                  >
                    <Typography
                      style={{
                        fontSize: 16,
                        textDecoration: 'underline',
                      }}
                    >
                      {item.link.title}
                    </Typography>
                  </Button>
                )}
              </TimelineContent>
            </TimelineItem>
          ))}
      </Timeline>
    </Box>
  );
}

export function StepFlowWidget({
  title,
  text,
  timeEpoch,
  isFirst,
  isLast,
  actions,
  handleDeeplink,
  setDeepLink,
  apiType,
  deep_link,
  add_step,
  overrideHandleDeepLink,
  ...props
}) {
  const dialogAction = (deep_link, apiType) => {
    handleDeeplink(deep_link, apiType, props, {
      fallbackOperation: setDeepLink,
      doneCallback: (refreshDeeplink) => {
        setDeepLink(refreshDeeplink);
        SMDialogControl.close();
        SMConfirmDialogControl.close();
      },
      errorCallback: (error) => {},
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        margin: 'auto',
        width: '70%',
        ...(isFirst ? { paddingTop: 40 } : {}),
      }}
    >
      <Box
        style={{
          cursor: deep_link ? 'pointer' : undefined,
          display: 'flex',
          border: '1px solid #dddddd',
          justifyContent: 'space-between',
          borderRadius: 8,
          borderWidth: 3,
          padding: 20,
          width: '100%',
          backgroundColor: '#f9f8f9',
        }}
        onClick={() => deep_link && dialogAction(deep_link, apiType)}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          }}
        >
          <Typography
            style={{
              fontWeight: 'bold',
              textOverflow: 'ellipsis',
              maxWidth: 'calc(100% - 20px)',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              fontSize: 18,
              padding: '0 0 10px 0',
            }}
          >
            {title}
          </Typography>
          <Typography>{text}</Typography>
        </div>
        {actions &&
          actions.map((action, index) => (
            <Button
              variant="outlined"
              size="small"
              style={{
                height: '100%',
                backgroundColor: '#ffffff',
                fontWeight: 'bold',
                fontSize: 16,
              }}
              onClick={() =>
                action.deep_link &&
                dialogAction(action.deep_link, get(add_step, action.apiType, 0))
              }
            >
              {action.title}
            </Button>
          ))}
      </Box>
      <div
        style={{
          width: 40,
          height: 80,
          display: 'flex',
          alignItems: 'flex-start',
        }}
      >
        <div
          style={{
            width: 25,
            height: '100%',
            borderRight:
              (isLast !== undefined && !isLast) || add_step
                ? '2px solid #d4d3d8'
                : 'none',
          }}
        />
      </div>
      {add_step && (
        <Button
          variant="contained"
          size="large"
          color="primary"
          style={{ marginLeft: 15 }}
          onClick={() =>
            add_step.deep_link &&
            dialogAction(add_step.deep_link, get(add_step, add_step.apiType, 0))
          }
        >
          {add_step.title}
        </Button>
      )}
    </div>
  );
}

export function TitleSubtitleMenuWidget({
  title,
  subtitle,
  menuItems,
  content,
  ...props
}) {
  const {
    deep_link,
    handleDeeplink,
    setDeepLink,
    apiType,
    overrideHandleDeepLink,
  } = props;

  return (
    <Box
      style={{
        border: '2px solid #dddddd',
        borderRadius: 4,
        margin: '10px 0 20px 10px',
        display: 'flex',
        alignItems: 'center',
        padding: 10,
        maxWidth: '100%',
        justifyContent: 'space-between',
      }}
      onClick={() =>
        deep_link &&
        (overrideHandleDeepLink || !apiType || apiType === 1
          ? setDeepLink
          : handleDeeplink)(deep_link, apiType, props, {
          fallbackOperation: setDeepLink,
          doneCallback: (refreshDeeplink) => {
            setDeepLink(refreshDeeplink);
            SMDialogControl.close();
            SMConfirmDialogControl.close();
          },
          errorCallback: (error) => {},
        })
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {content.map((block) => (
          <>
            <div>
              {block.subtitle && (
                <Typography
                  variant="subtitle1"
                  style={{ letterSpacing: 0.8, color: '#767676' }}
                >
                  {block.subtitle}
                </Typography>
              )}
              <Typography
                variant="h6"
                style={{ fontWeight: 'bold', padding: '0 0 10px 0' }}
              >
                {block.title}
              </Typography>
            </div>
            <div style={{ alignSelf: 'flex-start' }}>
              {block.menuItems &&
                block.menuItems.map((item, index) => (
                  <Tooltip title={item.title}>
                    <IconButton
                      key={item.title || index}
                      onClick={() => handleDeeplink(item.deep_link)}
                    >
                      <DynamicIcon
                        iconId={item.iconId}
                        title={item.title}
                        style={{ width: 15, height: 15 }}
                      />
                    </IconButton>
                  </Tooltip>
                ))}
            </div>
          </>
        ))}
      </div>
    </Box>
  );
}

export const OrderSearchResults = ({ searchResults, ...props }) => {
  const {
    cartItems,
    setCartItems,
    cartPrice,
    setCartPrice,
    setMessage,
    setSearchResults,
    handleDeeplink,
  } = props;
  const [formState, setFormState] = React.useState([]);
  const [previewImage, setPreviewImage] = React.useState(null);
  const [imageTitle, setImageTitle] = React.useState('');

  React.useEffect(() => {
    cartItems &&
      setFormState([
        ...cartItems.map((item) => ({
          ...item,
          cartQty: item.cartQty || 1,
        })),
      ]);
  }, [cartItems]);
  return (
    <div>
      {searchResults.map((order, index) => (
        <OrderDetailsWithImageCard
          loading={props.loading}
          formState={formState}
          setFormState={setFormState}
          order={order}
          setMessage={setMessage}
          cartItems={cartItems}
          setCartItems={setCartItems}
          cartPrice={cartPrice}
          setCartPrice={setCartPrice}
          setSearchResults={setSearchResults}
          handleDeeplink={handleDeeplink}
          setSearchResults={setSearchResults}
          searchResults={searchResults}
          addToCartDeeplink={props.addToCartDeeplink}
          showPrice={props.showPrice}
          addItem={props.addItem}
          getItemValue={props.getItemValue}
          handleChange={props.handleChange}
          responseAwaited={props.responseAwaited}
          setResponseAwaited={props.setResponseAwaited}
          setPreviewImage={setPreviewImage}
          setImageTitle={setImageTitle}
        />
      ))}
      <ImagePreview
        title={imageTitle}
        previewImage={previewImage}
        setPreviewImage={setPreviewImage}
      />
    </div>
  );
};
const CardShimmer = () => {
  const classes = useStyles();
  return (
    <Box style={{ display: 'flex', alignItems: 'center' }}>
      <Box
        style={{
          width: '20%',
          marginRight: 15,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Skeleton animation="wave" height={70} width={60} />
      </Box>
      <Box style={{ width: '48%' }}>
        <Skeleton animation="wave" height={14} style={{ marginBottom: 6 }} />
        <Skeleton
          animation="wave"
          height={14}
          width="80%"
          style={{ marginBottom: 6 }}
        />
        <Skeleton animation="wave" height={14} width="60%" />
      </Box>
      <Box
        style={{
          width: '32%',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
          alignSelf: 'flex-end',
        }}
      >
        <Skeleton animation="wave" height={30} width="50%" />
      </Box>
    </Box>
  );
};

const OrderDetailsWithImageCard = ({
  loading,
  order,
  setMessage,
  cartItems,
  setCartItems,
  cartPrice,
  setCartPrice,
  setSearchResults,
  handleDeeplink,
  deep_link,
  searchResults,
  formState,
  setFormState,
  addItem,
  setPreviewImage,
  setImageTitle,
  ...props
}) => {
  const classes = useStyles();
  const [quantity, setQuantity] = React.useState();
  const [presentInCart, setPresentInCart] = React.useState(
    order.presentInCart || false
  );
  React.useEffect(() => {
    setPresentInCart(false);
    setQuantity('');
  }, [order]);

  return (
    <>
      {loading ? (
        <div style={{ padding: 8 }}>
          <CardShimmer />
        </div>
      ) : (
        <Box
          style={{
            display: 'flex',
            alignItems: 'center',
            borderBottom: '1px solid #dddddd',
            padding: 8,
          }}
        >
          {!!order.imageUrl ? (
            <Box
              style={{
                marginRight: 15,
                height: 48,
                width: 48,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 4,
              }}
              onClick={() => {
                setPreviewImage(order.imageUrl);
                setImageTitle(order.title.title);
              }}
            >
              <img
                src={order.imageUrl}
                style={{
                  maxHeight: '48px',
                  maxWidth: '48px',
                  objectFit: 'contain',
                }}
              />
            </Box>
          ) : (
            <div
              style={{
                height: '48px',
                width: '48px',
                marginRight: 15,
                background: '#d8d8d8',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: 4,
              }}
            >
              <img
                src={require('assets/images/default_image.png')}
                style={{ width: '24px', objectFit: 'contain' }}
              />
            </div>
          )}
          <Box
            style={{
              width: ' calc(100% - 56px)',
              display: 'flex',
              flexDirection: 'column',
              background: '#ffffff',
              // background:"#EBEBF3"
            }}
          >
            <div
              style={{
                display: 'flex',
                marginRight: 4,
                justifyContent: 'space-between',
              }}
            >
              {order.title.title && (
                <Typography
                  variant="h6"
                  style={{
                    color: '#0F2965',
                    fontSize: '14px',
                    // overflow: 'hidden',
                    // whiteSpace: 'nowrap',
                    // textOverflow: 'ellipsis',
                    // maxWidth: '100%',
                    fontWeight: 'bold',
                    marginBottom: 4,
                  }}
                >
                  {order.title.title}
                </Typography>
              )}
              {order.title.subtitle && (
                <div
                  style={{
                    background: '#3E89D8',
                    padding: '0px 4px',
                    borderRadius: 4,
                    height: '100%',
                    padding: '1px 6px',
                  }}
                >
                  <Typography
                    noWrap
                    style={{
                      margin: 0,
                      color: '#ffffff',
                      fontSize: '10px',
                      fontWeight: 'bold',
                    }}
                  >
                    {order.title.subtitle}
                  </Typography>
                </div>
              )}
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
              }}
            >
              <div>
                {order.subtitle && (
                  <Typography style={{ fontSize: 14, color: 'grey' }}>
                    {order.subtitle}
                  </Typography>
                )}
                {(order.qty || order.mrp || order.ptr) && (
                  <Typography
                    variant="subtitle1"
                    className={classes.orderDetails}
                  >
                    {props.showPrice && (
                      <>
                        {/* <span style={{ fontWeight: 'bold' }}>PTR : </span>
                <span style={{ color: 'green', fontWeight: 'bold' }}>
                  &#8377;{` ${order.ptr}`}
                </span>
                {` | `} */}
                        <span
                          style={{
                            color: '#909090',
                            textDecoration: order.actualPrice && 'line-through',
                          }}
                        >
                          <span
                            style={{
                              color: order.actualPrice ? '#707070' : '#000000',
                              fontWeight: !order.actualPrice && 'bold',
                            }}
                          >
                            MRP :{' '}
                          </span>
                          <span
                            style={{
                              color: order.actualPrice ? '#707070' : '#00BC5E',
                              fontWeight: !order.actualPrice && 'bold',
                            }}
                          >
                            &#8377;{` ${order.actualPrice || order.mrp}`}{' '}
                          </span>
                        </span>
                        {order.actualPrice && (
                          <span
                            style={{
                              color: '#00BC5E',
                              fontWeight: 'bold',
                              marginLeft: 4,
                              fontSize: 15,
                            }}
                          >
                            &#8377;{` ${order.mrp}`}{' '}
                          </span>
                        )}
                        {/* {` | `} */}
                      </>
                    )}
                    {/* <span style={{ fontWeight: 'bold' }}>Avail. Qty : </span>
            <span style={{ color: 'grey', fontWeight: 'bold' }}>
              {` ${order.qty}`}{' '}
            </span> */}
                  </Typography>
                )}
              </div>

              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row-reverse',
                  alignItems: 'center',
                  alignSelf: 'flex-end',
                }}
              >
                {props.responseAwaited === order.id ? (
                  <Button
                    disabled={true}
                    style={{
                      color: '#414141',
                      fontWeight: 600,
                      border: '1px solid #d1d1d1',
                      width: 100,
                      padding: '4px 8px',
                    }}
                  >
                    <CircularProgress
                      disableShrink={true}
                      thickness={5}
                      size={24}
                    />
                  </Button>
                ) : !!(
                    formState && formState.find((item) => item.id === order.id)
                  ) ? (
                  <div style={{ width: 100 }}>
                    <InputWithIncrementDecrement
                      disableZeroInput={true}
                      minVal={0}
                      val={props.getItemValue(formState, order) || 1}
                      handleChange={(value) => {
                        props.handleChange(
                          formState,
                          setFormState,
                          order,
                          parseInt(value)
                        );
                      }}
                    />
                  </div>
                ) : (
                  <Button
                    style={{
                      color: '#414141',
                      fontWeight: 600,
                      border: '1px solid #d1d1d1',
                      width: 100,
                      padding: '4px 8px',
                    }}
                    onClick={() => {
                      props.setResponseAwaited(order.id);
                      addItem(order);
                    }}
                  >
                    ADD
                  </Button>
                )}
              </div>
            </div>
          </Box>
        </Box>
      )}
    </>
  );
};

export const IconWithMessage = ({
  iconId,
  message,
  overrideHandleDeepLink,
  setDeepLink,
  handleDeeplink,
  localSetDeeplink,
  buttons,
  ...props
}) => {
  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          padding: 20,
          margin: 20,
        }}
      >
        {iconId && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 100,
              marginBottom: 20,
            }}
          >
            <DynamicIcon
              iconId={iconId}
              style={{ width: 80, height: 80, color: '#00BC5E' }}
            />
          </div>
        )}
        <div style={{ width: '100%', textAlign: 'center' }}>
          {message && (
            <Typography style={{ fontSize: 17.5 }}>
              {message.split('\n').map((str) => (
                <p>{str}</p>
              ))}
            </Typography>
          )}
        </div>
        <div style={{ margin: '0px auto' }}>
          {buttons &&
            buttons.map((button, index) => (
              <Button
                style={{
                  marginTop: 20,
                  background: button.color || '#2e6bcf',
                  fontWeight: 'bold',
                  padding: '10px 30px',
                  color: '#ffffff',
                  marginLeft: index > 0 && 16,
                }}
                onClick={() =>
                  button.deep_link &&
                  (overrideHandleDeepLink ? setDeepLink : handleDeeplink)(
                    button.deep_link,
                    button.apiType,
                    undefined,
                    {
                      fallbackOperation: setDeepLink,
                      doneCallback: (refreshDeeplink) => {
                        setDeepLink(refreshDeeplink);
                        SMDIalogControl.close();
                        SMConfirmDialogControl.close();
                      },
                      errorCallback: (error) => {},
                    }
                  )
                }
              >
                {button.title}
              </Button>
            ))}
        </div>
      </Box>
    </div>
  );
};

export const SuccessMessage = ({ title, details, ...props }) => {
  return (
    <Box
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        background: props.backgroundColor || '#e6f7ea',
        padding: 10,
      }}
    >
      {title && (
        <Typography
          style={{
            fontSize: 16.5,
            fontWeight: 'bold',
            fontFamily: 'sans-serif',
            color: '#413e3e',
          }}
        >
          {title}
        </Typography>
      )}
      {details && (
        <Typography
          style={{
            fontSize: 15,
            fontWeight: 'bold',
            fontFamily: 'sans-serif',
            color: '#413e3e',
          }}
        >
          {details.split('\n').map((str) => (
            <p>{str}</p>
          ))}
        </Typography>
      )}
    </Box>
  );
};

export function BillingScreen(props) {
  const [shortcutKeyMap, setShortcutKeyMap] = React.useState({});
  const [shortcutHandlers, setShortcutHandlers] = React.useState({});
  const classes = useStyles();
  const [formState, setFormState] = React.useState([]);
  const [clickedButton, setClickedButton] = React.useState(-1);
  const formHandlers = FormControl(formState, setFormState);
  const [items, setItems] = React.useState(props.items);
  const [info, setInfo] = React.useState(props.info);
  const [payment, setPayment] = React.useState(props.payment);
  const { buttons, title } = props;
  const [presentItems, setPresentItems] = React.useState();
  const [responseAwaited, setResponseAwaited] = React.useState(-1);
  const fetchContent = (deeplink) => {
    props.handleDeeplink(deeplink).then((data) => {
      data &&
        setItems(
          data.items ||
            (
              get(data, ['sections', '0', 'cards', '0', 'content', '0'], {}) ||
              {}
            ).items ||
            items
        );
      data &&
        setPayment(
          data.payment ||
            (
              get(data, ['sections', '0', 'cards', '0', 'content', '0'], []) ||
              {}
            ).payment ||
            payment
        );
      data && setResponseAwaited(-1);
    });
  };

  const handleButtonClick = (button, index) => {
    if (index !== clickedButton) {
      setClickedButton(index);
      button.deep_link &&
        sendAnalyticsEvent(`${button.name} Bill Button Clicked`, {
          deep_link: button.deep_link,
          formBody: { ...formState },
          apiType: button.apiType || 1,
        });
      button.deep_link &&
        props
          .handleDeeplink(button.deep_link, button.apiType || 1, formState, {
            doneCallback: (refreshDeeplink) => {
              props.setDeepLink(refreshDeeplink);
            },
          })
          .then((response) => {
            setClickedButton(-1);
            if (response) {
              sendAnalyticsEvent('Bill Button response', {
                deep_link: button.deep_link,
                response: { ...response },
              });
              setPresentItems({ columns: [...presentItems.columns], rows: [] });
              (formHandlers.resetFormState || (() => {}))();
              response.refreshDeeplink &&
                props.setDeepLink(response.refreshDeeplink);
              response.redirectLink && props.setDeepLink(response.redirectLink);
            }
          });
    }
  };
  configure({
    ignoreTags: ['input', 'select', 'textarea'],
    ignoreEventsCondition: function () {},
  });

  React.useEffect(() => {
    let tempShortcutKeyMap = {};
    let tempShortcutHandlers = {};
    !!buttons &&
      buttons.map((button, index) => {
        if (button.shortcutKeys) {
          tempShortcutKeyMap[`${button.name}_button`] = [
            ...button.shortcutKeys,
          ];
          tempShortcutHandlers[`${button.name}_button`] = () => {
            handleButtonClick(button.deep_link, button.apiType || 1, index);
          };
        }
      });

    setShortcutKeyMap({ ...tempShortcutKeyMap });
    setShortcutHandlers(preventDefaultHandlers({ ...tempShortcutHandlers }));
  }, [buttons, formState]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        background: '#f9f9fc',
      }}
    >
      <GlobalHotKeys
        keyMap={shortcutKeyMap}
        handlers={shortcutHandlers}
        allowChanges={true}
      />
      <div className={classes.titleContainer} style={{ zIndex: 2 }}>
        <Typography className={classes.title}>{title}</Typography>
        {buttons &&
          buttons.map((button, index) => (
            <Button
              style={{ background: button.color || '#2e6bcf' }}
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={() => {
                handleButtonClick(button, index);
              }}
            >
              {clickedButton === index ? (
                <CircularProgress
                  thickness={5}
                  size={25}
                  style={{
                    color: button.textColor || '#ffffff',
                    marginTop: 6,
                  }}
                />
              ) : (
                <>
                  {button.iconId && (
                    <DynamicIcon
                      iconId={button.iconId}
                      insideColoredButton
                      style={{
                        marginLeft: button.name ? 10 : 0,
                        height: 20,
                        width: 20,
                        color: button.textColor || '#ffffff',
                        fontSize: 15,
                      }}
                    />
                  )}
                  {button.name && (
                    <div
                      className={classes.buttonText}
                      style={{
                        marginLeft: !button.iconId && 10,
                        color: button.textColor || '#ffffff',
                      }}
                    >
                      {button.name}
                    </div>
                  )}{' '}
                </>
              )}
            </Button>
          ))}
      </div>
      {info && (
        <div
          style={{
            width: '100%',
            background: '#f9f9fc',
            padding: '16px 32px',
            display: 'flex',
            justifyContent: 'flex-start',
          }}
        >
          {info.map((group, index) => (
            <div style={{ width: '45%' }}>
              <FormGroup
                index={index}
                formHandlers={formHandlers}
                formData={formState}
                group={group}
              />
            </div>
          ))}
        </div>
      )}
      <div style={{ display: 'flex', width: '100%' }}>
        {props.images && (
          <div style={{ maxWidth: '50%', padding: '8px 24px' }}>
            <ImagesWidget
              defaultPadding={true}
              size={props.images.size}
              images={props.images.images}
              title={props.images.title}
            />
          </div>
        )}
        {props.texts && (
          <div style={{ maxWidth: '50%', padding: '8px 24px' }}>
            <TitleSubtitleCarouselWidget
              defaultPadding={true}
              wrapContent={true}
              content={props.texts.content}
              title={props.texts.title}
            />
          </div>
        )}
      </div>
      {items && (
        <div
          style={{
            width: '100%',
            padding: '8px 32px',
            background: '#ffffff',
            height:
              items.size === 'small'
                ? '36vh'
                : items.size === 'medium'
                ? '46vh'
                : items.size === 'large'
                ? '56vh'
                : items.size === 'xlarge'
                ? '66vh'
                : '36vh',
          }}
        >
          <SearchAndAddWidget
            url={props.url}
            presentItems={presentItems}
            setPresentItems={setPresentItems}
            setDeepLink={props.setDeepLink}
            formData={formState}
            handleDeeplink={props.handleDeeplink}
            items={items}
            fetchContent={fetchContent}
            responseAwaited={responseAwaited}
            setResponseAwaited={setResponseAwaited}
            {...formHandlers}
            tableShortcuts={items.tableShortcuts}
            setMessage={props.setMessage}
          />
        </div>
      )}
      <div
        style={{
          width: '100%',
          background: '#ffffff',
          padding: '8px 32px',
          display: 'flex',
          justifyContent: 'flex-end',
        }}
      >
        {payment &&
          payment.map((group, index) => (
            <FormGroup
              index={index}
              formHandlers={formHandlers}
              formData={formState}
              group={group}
              onFieldUpdate={fetchContent}
              handleDeeplink={props.handleDeeplink}
            />
          ))}
      </div>
    </div>
  );
}

const TableTextField = ({
  _key,
  row,
  focus,
  dataType,
  fieldVal,
  setOpenDialogForRow,
  setDialogContent,
  popupKey,
  popupContent,
  maxLength,
  ...props
}) => {
  const [val, setVal] = React.useState('');
  React.useEffect(() => {
    (!!fieldVal || fieldVal === 0 || fieldVal === '') && setVal(fieldVal);
  }, [fieldVal]);
  return (
    <TextField
      autoFocus={focus}
      key={_key}
      onKeyPress={(e) => {
        props.onKeyPress(e);
        if (popupKey && e.key === popupKey) {
          setOpenDialogForRow(row);
          setDialogContent(popupContent);
        }
      }}
      value={val}
      disableUnderline
      InputProps={{
        style:
          dataType === 1 || dataType === 2
            ? { width: 80 }
            : { minWidth: 130, maxWidth: 150 },
      }}
      inputProps={{
        maxLength: maxLength,
      }}
      onChange={(event) => {
        setVal(event.target.value);
        (props.handleChange || (() => {}))(event.target.value);
      }}
      fullWidth
      size="small"
      variant="outlined"
    />
  );
};

const TableDateField = ({
  row,
  _key,
  fieldVal,
  disablePastDates,
  format,
  views,
  ...props
}) => {
  const [val, setVal] = React.useState(null);
  const [error, setError] = React.useState(false);
  React.useEffect(() => {
    (!!fieldVal || fieldVal === null) && setVal(fieldVal);
    (!!fieldVal || fieldVal === null) && setError(false);
  }, [fieldVal]);
  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <KeyboardDatePicker
        InputProps={{ style: { minWidth: 150, maxWidth: 180 } }}
        key={_key}
        size="small"
        error={error}
        helperText={error && 'Invalid Date'}
        disablePast={disablePastDates}
        format={format}
        views={views}
        inputVariant="outlined"
        value={val}
        onChange={(value) => {
          !!value && !value.isValid() && setError(true);
          if ((!!value && value.isValid()) || !value) {
            if (
              value &&
              ((disablePastDates && value.unix() < Date.now() / 1000) ||
                value.unix() < 0)
            )
              setError(true);
            else {
              setError(false);
              (props.handleChange || (() => {}))(value);
            }
          }
        }}
        fullWidth={true}
        cancelLabel={
          <Typography style={{ fontWeight: 'bold' }}>CANCEL</Typography>
        }
        okLabel={<Typography style={{ fontWeight: 'bold' }}>OK</Typography>}
      />
    </MuiPickersUtilsProvider>
  );
};

const DialogBuilder = ({
  openDialogForRow,
  setOpenDialogForRow,
  dialogContent,
  setDialogContent,
  fetchContent,
  ...props
}) => {
  const classes = useStyles();
  const [formFields, setFormFields] = React.useState(dialogContent.fields);
  const [pseudoFormState, setPseudoFormState] = React.useState([]);
  const [clickedButton, setClickedButton] = React.useState(-1);
  const formHandlers = FormControl(pseudoFormState, setPseudoFormState);
  React.useEffect(() => {
    openDialogForRow &&
      formHandlers.setFormState({ ['id']: openDialogForRow.id });
    setTimeout(() => {
      !openDialogForRow && setDialogContent({});
    }, 100);
  }, [openDialogForRow]);

  React.useEffect(() => {
    if (!!openDialogForRow && dialogContent) {
      let tempFields = [...(dialogContent.fields || [])];
      tempFields.forEach((field) => {
        if (field.multipleFields) {
          field.subFields.forEach((subField) => {
            if (subField.putDefaultValue && subField.fieldType === 0) {
              subField['text'] =
                subField.text || openDialogForRow[subField.key] || '';
            }
          });
        } else if (field.putDefaultValue && field.fieldType === 0) {
          field['text'] = field.text || openDialogForRow[field.key] || '';
        }
      });
      setFormFields(tempFields);
    }
  }, [dialogContent, openDialogForRow]);

  const handleButtonClick = (deeplink, apiType, index) => {
    if (index !== clickedButton) {
      setClickedButton(index);
      deeplink &&
        sendAnalyticsEvent('Popup Button Clicked', {
          deep_link: deeplink,
          formBody: { ...pseudoFormState },
          apiType: apiType,
        });
      deeplink &&
        props
          .handleDeeplink(deeplink, apiType, pseudoFormState, {
            doneCallback: (refreshDeeplink) => {
              props.setDeepLink(refreshDeeplink);
            },
          })
          .then((response) => {
            setClickedButton(-1);
            if (response) {
              sendAnalyticsEvent('Popup Button response', {
                deep_link: deeplink,
                response: { ...response },
              });
              (formHandlers.resetFormState || (() => {}))();
              response.refreshDeeplink &&
                props.setDeepLink(response.refreshDeeplink);
            }
          });
    }
  };

  return (
    <Dialog
      open={openDialogForRow}
      onClick={(e) => e.stopPropagation()}
      onClose={() => setOpenDialogForRow(null)}
      PaperProps={{
        style: { width: '50vw', overflow: 'hidden' },
      }}
    >
      <AppBar position="relative" elevation={0} className={classes.titlebar}>
        <Toolbar
          style={{
            justifyContent:
              dialogContent && dialogContent.title
                ? 'space-between'
                : 'flex-end',
            background: '#ffffff',
            minHeight: 10,
            height: 40,
            padding: 0,
          }}
        >
          <Typography
            style={{ fontSize: '20px', color: '#505050', opacity: 1 }}
            noWrap={true}
            flex={1}
            spacing={1}
            className={classes.dialogTitle}
            variant="h6"
          >
            {dialogContent && dialogContent.title}
          </Typography>
          <IconButton
            edge="start"
            style={{ color: '#505050' }}
            onClick={() => setOpenDialogForRow(null)}
            aria-label="close"
          >
            <CloseOutlined />
          </IconButton>
        </Toolbar>
      </AppBar>
      <DialogContent
        style={{
          padding: 16,
          overflow: 'auto',
          maxHeight: '90vh',
          width: '100%',
          background: '#FDFDFF',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            width: '100%',
            justifyContent: 'space-around',
          }}
        >
          {dialogContent.fields && (
            <FormGroup
              focus={true}
              size="small"
              handleDeeplink={props.handleDeeplink}
              index={0}
              formHandlers={formHandlers}
              formData={pseudoFormState}
              group={{ fields: formFields }}
              onFieldUpdate={(deeplink) => {
                fetchContent(deeplink);
                setOpenDialogForRow(null);
              }}
            ></FormGroup>
          )}
        </div>
      </DialogContent>
      {dialogContent.buttons && (
        <DialogActions
          className={classes.dialogActions}
          style={{ padding: 0, margin: 0 }}
        >
          {dialogContent.buttons.map((button, index) => (
            <Button
              disabled={clickedButton !== -1}
              style={{
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
                margin: 10,
                background: '#2e6bcf',
                color: '#ffffff',
                padding: '5px 8px 5px 8px',
                fontWeight: 'bold',
                fontSize: 18,
              }}
              onClick={() =>
                handleButtonClick(button.deep_link, button.apiType, index)
              }
            >
              {(clickedButton === index && (
                <CircularProgress
                  thickness={5}
                  size={28}
                  style={{ color: '#ffffff' }}
                />
              )) ||
                button.title}
            </Button>
          ))}
        </DialogActions>
      )}
    </Dialog>
  );
};

export const ClickableTableWidget = ({
  popperReference,
  fetchContent,
  ...props
}) => {
  const [rowFocused, setRowFocused] = React.useState(null);
  const [shortcutKeyMap, setShortcutKeyMap] = React.useState({});
  const [shortcutHandlers, setShortcutHandlers] = React.useState({});
  const [openDialogForRow, setOpenDialogForRow] = React.useState(null);
  const [dialogContent, setDialogContent] = React.useState({});
  const [navigationIndex, setNavigationIndex] = React.useState(-1);
  const classes = useStyles();
  const handleKey = (e) => {
    switch (e.keyCode) {
      case 40:
        if (
          props.items &&
          props.items.rows &&
          navigationIndex < props.items.rows.length - 1
        ) {
          setNavigationIndex(navigationIndex + 1);
          navigationIndex > -1 &&
            popperReference.current &&
            popperReference.current.scrollBy(0, 40);
        } else if (
          props.items &&
          props.items.rows &&
          navigationIndex === props.items.rows.length - 1
        ) {
          setNavigationIndex(0);
          popperReference.current &&
            popperReference.current.scrollBy(
              0,
              -1 * popperReference.current.scrollHeight
            );
        }
        break;
      case 38:
        if (props.items && props.items.rows && navigationIndex > 0) {
          setNavigationIndex(navigationIndex - 1);
          popperReference.current && popperReference.current.scrollBy(0, -40);
        } else if (props.items && props.items.rows && navigationIndex === 0) {
          setNavigationIndex(props.items.rows.length - 1);
          popperReference.current &&
            popperReference.current.scrollBy(
              0,
              popperReference.current.scrollHeight
            );
        }
        break;
      case 13:
        if (props.items && props.items.rows && navigationIndex !== -1) {
          (props.rowClickAction || (() => {}))(
            props.items.rows[navigationIndex],
            props.items.columns.map((column) => column.key)
          );
          setNavigationIndex(-1);
        }
        break;
    }
  };
  configure({
    ignoreTags: ['input', 'select', 'textarea'],
    ignoreEventsCondition: function () {},
  });
  React.useEffect(() => {
    props.searchPopper && window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [navigationIndex]);

  React.useEffect(() => {
    openDialogForRow &&
      dialogContent &&
      Object.keys(dialogContent).length > 0 &&
      dialogContent.fields.forEach((field) => {});
  }, [dialogContent, openDialogForRow]);

  React.useEffect(() => {
    let tempShortcutKeyMap = {};
    let tempShortcutHandlers = {};

    (props.tableShortcuts || []).forEach((shortcut) => {
      tempShortcutKeyMap[shortcut.name] = [...shortcut.keys];
      tempShortcutHandlers[shortcut.name] = () => {
        rowFocused &&
          shortcut.deeplink &&
          sendAnalyticsEvent(`${shortcut.name} Table Shortcut used`, {
            deep_link: shortcut.deeplink,
            row: rowFocused,
            apiType: shortcut.apiType || 1,
          });

        rowFocused &&
          shortcut.deeplink &&
          props
            .handleDeeplink(
              shortcut.deeplink,
              shortcut.apiType || 1,
              { ['row']: rowFocused },
              {
                doneCallback: (refreshDeeplink) => {
                  props.setDeepLink(refreshDeeplink);
                },
              }
            )
            .then((response) => {
              if (response) {
                response.refreshDeeplink &&
                  props.setDeepLink(response.refreshDeeplink);
              }
            });
      };
    });
    setShortcutKeyMap({ ...tempShortcutKeyMap });
    setShortcutHandlers(preventDefaultHandlers({ ...tempShortcutHandlers }));
  }, [rowFocused, props.tableShortcuts]);

  return (
    <>
      <GlobalHotKeys
        keyMap={shortcutKeyMap}
        handlers={shortcutHandlers}
        allowChanges={true}
      />
      <TableContainer style={{ border: '1px solid #d8d8d8' }}>
        <Table stickyHeader={true} aria-label="simple table">
          <TableHead>
            <TableRow>
              {props.items.columns &&
                props.items.columns.map((column, index) => (
                  <TableCell
                    style={{
                      background: '#f9f9f9',
                      borderLeft:
                        index > 0 && !column.hideBorder && '1px solid #d8d8d8',
                      borderCollapse: 'colapse',
                    }}
                  >
                    {column.title}
                  </TableCell>
                ))}
              {props.deleteAction && (
                <TableCell
                  style={{
                    width: 40,
                    background: '#f9f9f9',
                    position: 'sticky',
                    right: 0,
                  }}
                />
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {props.items.rows &&
              props.items.rows.map((row, index) => (
                <TableRow
                  hover={props.searchPopper}
                  onClick={() => {
                    setNavigationIndex(-1);
                    (props.rowClickAction || (() => {}))(
                      row,
                      props.items.columns.map((column) => column.key)
                    );
                  }}
                  style={{
                    borderCollapse: 'collapse',
                    cursor: !!props.rowClickAction && 'pointer',
                  }}
                >
                  {props.items.columns &&
                    props.items.columns.map((item, i) => (
                      <TableCell
                        onBlur={() => {
                          setRowFocused(null);
                        }}
                        onFocus={() => {
                          setRowFocused(row);
                        }}
                        style={{
                          borderLeft:
                            i > 0 && !item.hideBorder && '1px solid #d8d8d8',
                          borderCollapse: 'collapse',
                          padding: 10,
                          background: index === navigationIndex && '#e8e8e888',
                          ...(item.dataType === 1 || item.dataType === 2
                            ? { width: 100 }
                            : item.dataType === 0
                            ? { width: 80 }
                            : item.isEditable
                            ? { width: 180 }
                            : {}),
                        }}
                      >
                        {item.isEditable ? (
                          item.dataType === 3 ? (
                            <TableDateField
                              row={row}
                              _key={row.id + '' + item.key}
                              disablePastDates={item.disablePastDates}
                              format={item.format || 'DD/MM/YYYY'}
                              views={
                                item.format &&
                                item.format !== 'DD/MM/YYYY' && [
                                  ...(item.format.includes('M')
                                    ? ['month']
                                    : []),
                                  ...(item.format.includes('Y')
                                    ? ['year']
                                    : []),
                                ]
                              }
                              fieldVal={
                                ((props.formData.items || []).find(
                                  (element) => element.id === row.id
                                ) || {})[item.key]
                                  ? moment.unix(
                                      ((props.formData.items || []).find(
                                        (element) => element.id === row.id
                                      ) || {})[item.key]
                                    )
                                  : null
                              }
                              handleChange={(val) =>
                                (props.updateAction || (() => {}))(
                                  row,
                                  item.key,
                                  props.formData,
                                  item.dataType,
                                  !!val ? val.unix() : null
                                )
                              }
                            />
                          ) : item.dataType === 5 ? (
                            <EditableDropdownWidget
                              key={row.id + '' + item.key}
                              insideTable={true}
                              hideCloseIcon={true}
                              options={
                                (row[item.key] && row[item.key].options) ||
                                item.options
                              }
                              selected={row[item.key] && row[item.key].selected}
                              hint={item.title}
                              disableCustomInput={item.disableCustomInput}
                              handleChange={(val) => {
                                (props.updateAction || (() => {}))(
                                  row,
                                  item.key,
                                  props.formData,
                                  item.dataType,
                                  val
                                );
                              }}
                            />
                          ) : (
                            <TableTextField
                              setOpenDialogForRow={setOpenDialogForRow}
                              setDialogContent={setDialogContent}
                              popupContent={item.popupContent}
                              popupKey={item.popupKey}
                              row={row}
                              focus={index === 0 && item.key === props.focus}
                              _key={item.key + '' + row.id}
                              onKeyPress={(e) =>
                                props.onKeyPress(e, item.dataType)
                              }
                              maxLength={item.maxLength}
                              dataType={item.dataType}
                              fieldVal={
                                row[item.key] || (row[item.key] === 0 ? 0 : '')
                              }
                              handleChange={(val) =>
                                (props.updateAction || (() => {}))(
                                  row,
                                  item.key,
                                  props.formData,
                                  item.dataType,
                                  val
                                )
                              }
                            />
                          )
                        ) : item.dataType === 4 ? (
                          (row[item.key] &&
                            moment.unix(row[item.key]).format('DD MMM YYYY')) ||
                          ''
                        ) : (
                          <Typography
                            style={{
                              fontSize: 14,
                              fontWeight: item.bold && 'bold',
                              color: item.color,
                            }}
                          >
                            {item.dataType === 6
                              ? item.displayText
                              : row[item.key] || ''}
                          </Typography>
                        )}
                      </TableCell>
                    ))}
                  {props.deleteAction && (
                    <TableCell
                      onBlur={() => {
                        setRowFocused(null);
                      }}
                      onFocus={() => {
                        setRowFocused(row);
                      }}
                      style={{
                        width: 40,
                        padding: 0,
                        verticalAlign: 'center',
                        position: 'sticky',
                        right: 0,
                        background: '#ffffff',
                      }}
                    >
                      {props.responseAwaited === row.id ? (
                        <IconButton>
                          <CircularProgress disableShrink={true} size={20} />
                        </IconButton>
                      ) : (
                        <IconButton
                          onClick={(event) => {
                            event.stopPropagation();
                            if (props.responseAwaited === -1) {
                              props.setResponseAwaited(row.id);
                              props.deleteAction(row);
                            }
                          }}
                        >
                          <DynamicIcon
                            iconId={159}
                            style={{ height: 20, width: 20 }}
                          />
                        </IconButton>
                      )}
                    </TableCell>
                  )}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <DialogBuilder
        fetchContent={fetchContent}
        handleDeeplink={props.handleDeeplink}
        openDialogForRow={openDialogForRow}
        setOpenDialogForRow={setOpenDialogForRow}
        dialogContent={dialogContent}
        setDialogContent={setDialogContent}
      />
    </>
  );
};

export const TabularSearchResults = ({
  setMessage,
  cartItems,
  setCartItems,
  cartPrice,
  setCartPrice,
  setSearchResults,
  handleDeeplink,
  searchResults,
  addItem,
  ...props
}) => {
  const [formState, setFormState] = React.useState([]);

  React.useEffect(() => {
    cartItems &&
      setFormState([
        ...cartItems.map((item) => ({
          ...item,
          cartQty: item.cartQty || 1,
        })),
      ]);
  }, [cartItems]);

  return (
    <>
      <TableContainer>
        <Table stickyHeader={true} aria-label="simple table">
          <TableHead>
            <TableRow>
              {searchResults.columns &&
                searchResults.columns.map((column, index) => (
                  <TableCell
                    style={{ border: 'none', fontSize: 16, color: '#8d8d8d' }}
                  >
                    {column.title}
                  </TableCell>
                ))}
              {addItem && (
                <TableCell
                  style={{ border: 'none', color: '#8d8d8d' }}
                ></TableCell>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {searchResults.rows &&
              searchResults.rows.map((row, index) => (
                <TableRow style={{ background: index % 2 === 0 && '#f9f9f9' }}>
                  {searchResults.columns &&
                    searchResults.columns.map((item, index) => (
                      <TableCell
                        style={{
                          fontSize: 16,
                          border: 'none',
                          borderCollapse: 'collapse',
                          padding: item.containsImage ? 16 : 10,
                          fontWeight: item.isBold && 'bold',
                          color: item.color || '#666666',
                          textDecoration: item.strikeText && 'line-through',
                        }}
                      >
                        {item.isCurrencyField && row[item.key] && (
                          <span>&#8377;&nbsp;</span>
                        )}
                        {item.containsImage ? (
                          <Box
                            style={{
                              width: 65,
                              height: 65,
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              margin: '0px auto',
                            }}
                          >
                            <img
                              src={row[item.key]}
                              style={{
                                maxHeight: '60px',
                                maxWidth: '60px',
                                objectFit: 'contain',
                              }}
                            />
                          </Box>
                        ) : item.hasSubtitle ? (
                          <>
                            {row[item.key].title || ''}
                            {row[item.key].subtitle && (
                              <>
                                <br />
                                <span
                                  style={{
                                    fontSize: 14,
                                    color: item.subtitleColor,
                                  }}
                                >
                                  {row[item.key].subtitle || ''}
                                </span>
                              </>
                            )}
                          </>
                        ) : (
                          row[item.key] || ''
                        )}
                      </TableCell>
                    ))}
                  {addItem && (
                    <TableCell
                      align="center"
                      style={{
                        border: 'none',
                        padding: 10,
                      }}
                    >
                      {props.responseAwaited === row.id ? (
                        <Button
                          disabled={true}
                          style={{
                            color: '#414141',
                            fontWeight: 600,
                            border: '1px solid #d1d1d1',
                            width: 100,
                            padding: '4px 8px',
                          }}
                        >
                          <CircularProgress
                            disableShrink={true}
                            thickness={5}
                            size={24}
                          />
                        </Button>
                      ) : !!(
                          formState &&
                          formState.find((item) => item.id === row.id)
                        ) ? (
                        <div style={{ width: 100, margin: '0px auto' }}>
                          <InputWithIncrementDecrement
                            disableZeroInput={true}
                            minVal={0}
                            val={props.getItemValue(formState, row) || 1}
                            handleChange={(value) => {
                              props.handleChange(
                                formState,
                                setFormState,
                                row,
                                parseInt(value)
                              );
                            }}
                          />
                        </div>
                      ) : (
                        <Button
                          variant="contained"
                          color="primary"
                          style={{
                            // color: '#414141',
                            fontWeight: 600,
                            // border: '1px solid #d1d1d1',
                            width: 100,
                            padding: '4px 8px',
                          }}
                          onClick={() => {
                            props.setResponseAwaited(row.id);
                            addItem(row);
                          }}
                        >
                          ADD
                        </Button>
                      )}
                    </TableCell>
                  )}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export const ExceptionWidget = ({ name, time, event, eventColor }) => {
  return (
    <Box p={1}>
      <Box display="flex" justifyContent="space-between">
        <Typography>{name}</Typography>
        <Typography>{moment.unix(time).format('DD MMM YYYY')}</Typography>
      </Box>
      <Typography style={{ color: eventColor }}>{event}</Typography>
    </Box>
  );
};

export function TitlebarWidget({ title, subtitle, logo, ...props }) {
  const classes = useStyles();

  return (
    <Box
      p={1}
      style={{ display: 'flex', paddingTop: 10, background: '#2e6bcf' }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{ paddingLeft: 5, paddingRight: 20 }}
      >
        <Avatar
          style={{
            height: '54px',
            width: '54px',
            objectFit: 'contain',
            background: '#ffffff',
            padding: 3,
            color: '#2e6bcf',
            fontSize: 30,
          }}
          src={logo}
        >
          {title.charAt(0)}
        </Avatar>
      </Box>
      <Box>
        <Typography style={{ color: '#ffffff' }} variant="h6">
          {title}
        </Typography>

        {subtitle && (
          <Typography style={{ color: '#ffffff' }} variant="subtitle2">
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

export function FullwidthTitlebarWidget({ title, subtitle, logo, ...props }) {
  const classes = useStyles();

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // background: '#2e6bcf',
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="center">
        <img
          style={{
            width: '100%',
            objectFit: 'contain',
          }}
          src={logo}
        />
      </Box>
      <Divider style={{ width: '100%', color: '#2e6bcf' }} />
      {(!title || !subtitle) && (
        <Box>
          <Typography style={{ color: '#ffffff' }} variant="h6">
            {title}
          </Typography>

          {subtitle && (
            <Typography style={{ color: '#ffffff' }} variant="subtitle2">
              {subtitle}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
}

export const WaitingPreview = ({
  title,
  subtitle,
  progressStatusDeepLink,
  ...props
}) => {
  const { handleDeeplink } = props;
  React.useEffect(() => {
    if (progressStatusDeepLink) {
      const interval = setInterval(() => {
        handleDeeplink(progressStatusDeepLink)
          .then((data) => {
            if (data.done) {
              clearInterval(interval);
              data.refreshDeeplink && props.setDeepLink(data.refreshDeeplink);
            }
          })
          .catch(console.log);
      }, 3000);
    }
  }, [progressStatusDeepLink]);

  const [confirmCancel, setconfirmCancel] = React.useState(false);
  const history = useHistory();
  const onBackButtonEvent = (e) => {
    e.preventDefault();
    if (!confirmCancel) {
      if (window.confirm('Are you sure you want to go back ?')) {
        history.goBack();
        setconfirmCancel(true);
      } else {
        window.history.pushState(null, null, window.location.pathname);
        setconfirmCancel(false);
      }
    }
  };

  React.useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener('popstate', onBackButtonEvent);
    return () => {
      console.log('removed');
      window.removeEventListener('popstate', onBackButtonEvent);
    };
  }, [confirmCancel]);

  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 40,
      }}
    >
      <div style={{ marginBottom: 20 }}>
        <CircularProgress disableShrink={true} thickness={4} size={160} />
      </div>
      <div style={{ width: '95%' }}>
        {title && (
          <Typography style={{ textAlign: 'center', fontSize: 20 }}>
            {title.split('\n').map((str) => (
              <p>{str}</p>
            ))}
          </Typography>
        )}
      </div>
      <div style={{ width: '95%' }}>
        {subtitle && (
          <Typography
            style={{ textAlign: 'center', fontSize: 16, color: '#505050' }}
          >
            {subtitle.split('\n').map((str) => (
              <p>{str}</p>
            ))}
          </Typography>
        )}
      </div>
    </Box>
  );
};

export const WebStoreBanner = (props) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          width: '100%',
          height: props.isMobile ? '130px' : '180px',
        }}
      >
        <div
          style={{
            width: '25%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginLeft: '5px',
          }}
        >
          <img
            src={props.logo || 'https://pharmacyone-images.s3.ap-south-1.amazonaws.com/logo/1P_new_logo_with_text.jpeg'}
            style={{ width: '100%', objectFit: 'contain' }}
          />
        </div>
        <div
          style={{
            width: '75%',
            padding: props.isMobile ? '15px 10px' : '16px 24px',
            height: '100%',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              width: 'calc(100%)',
              background: '#2e6bcf',
              height: '100%',
              borderRadius: props.isMobile ? '0px 50px' : '0px 75px',
            }}
          >
            <Typography
              variant="h6"
              style={{
                color: '#ffffff',
                fontWeight: 'bold',
                fontSize: props.isMobile ? 18 : 28,
                textAlign: 'center',
                // marginBottom: 8,
                maxWidth: '80%',
              }}
            >
              {props.title}
            </Typography>
            <Typography
              variant="h6"
              style={{
                maxWidth: '80%',
                color: '#ffffff',
                fontSize: props.isMobile ? 12 : 18,
                textAlign: 'center',
                fontWeight: 'bold',
              }}
            >
              {props.subtitle}
            </Typography>
          </div>
        </div>
      </div>
      <Divider style={{ width: '100%', color: '#2e6bcf' }} />
    </>
  );
};

export const ButtonsGroupWidget = ({ buttons, ...props }) => {
  const classes = useStyles();
  const onButtonClick = (button) => {
    if (button.deeplink) {
      sendAnalyticsEvent(`${button.title || 'Button groups'} button Clicked`, {
        deep_link: button.deeplink,
        apiType: button.apiType,
      });

      (props.overrideHandleDeepLink || !button.apiType || button.apiType === 1
        ? props.setDeepLink
        : props.handleDeeplink)(button.deeplink, button.apiType, props, {
        fallbackOperation: props.setDeepLink,
        doneCallback: (refreshDeeplink) => {
          props.setDeepLink(refreshDeeplink);
          SMDialogControl.close();
          SMConfirmDialogControl.close();
        },
        errorCallback: (error) => {},
      });
    }
  };
  return (
    <Box
      p={1.25}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
      }}
    >
      {buttons.map((button, index) => (
        <Button
          color="primary"
          onClick={() => onButtonClick(button)}
          style={{ marginTop: index > 0 && 8, padding: '8px 0px' }}
        >
          {(button.iconId || button.iconId === 0) && (
            <DynamicIcon iconId={button.iconId} style={{ color: '#2e6bcf' }} />
          )}
          <Typography style={{ margin: 2 }}>{button.title}</Typography>
        </Button>
      ))}
    </Box>
  );
};

export const ImagePreview = ({
  previewImage,
  setPreviewImage,
  title,
  ...props
}) => {
  const [openDialog, setOpenDialog] = React.useState(false);
  const classes = useStyles();
  React.useEffect(() => {
    setTimeout(() => {
      !!previewImage && setOpenDialog(true);
    }, 100);
  }, [previewImage]);
  React.useEffect(() => {
    setTimeout(() => {
      !openDialog && setPreviewImage(null);
    }, 100);
  }, [openDialog]);
  return (
    <Dialog
      open={openDialog}
      onClick={(e) => e.stopPropagation()}
      onClose={() => setOpenDialog(false)}
      aria-labelledby="form-dialog-title"
      PaperProps={{
        style: { maxWidth: '95vw', overflow: 'hidden' },
      }}
    >
      <DialogContent
        style={{
          padding: 0,
          overflow: 'auto',
          maxHeight: '90vh',
          width: '100%',
          background: '#FDFDFF',
        }}
      >
        <Toolbar
          style={{
            justifyContent: title ? 'space-between' : 'flex-end',
            background: 'transparent',
            minHeight: 10,
            height: 40,
            padding: 0,
          }}
        >
          <Typography
            style={{ fontSize: '16px', color: '#505050', opacity: 1 }}
            noWrap={true}
            flex={1}
            spacing={1}
            className={classes.dialogTitle}
          >
            {title}
          </Typography>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => setOpenDialog(false)}
            aria-label="close"
          >
            <CloseOutlined />
          </IconButton>
        </Toolbar>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src={previewImage}
            style={{
              maxHeight: '80vh',
              maxWidth: 'calc(100%)',
              objectFit: 'contain',
            }}
          ></img>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export const ImagesWidget = ({
  size,
  images,
  title,
  subtitle,
  defaultPadding,
  ...props
}) => {
  const classes = useStyles();
  const [previewImage, setPreviewImage] = React.useState(null);
  const dimensions =
    size === 'xsmall'
      ? 150
      : size === 'small'
      ? 250
      : size === 'medium'
      ? 350
      : size === 'large'
      ? 450
      : size === 'xlarge'
      ? 600
      : 150;
  return (
    <Box style={{ padding: defaultPadding ? 0 : '8px 16px' }}>
      <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: 8 }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="subtitle1" style={{ color: '#707070' }}>
          {subtitle.split('\n').map((str) => (
            <p style={{ margin: 0, padding: 0 }}>{str}</p>
          ))}
        </Typography>
      )}
      <Box
        className={classes.carouselContainer}
        style={{ display: 'flex', overflowX: 'auto' }}
      >
        {images.map((item) => (
          <Box
            style={{
              maxWidth: dimensions,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Box
              p={1}
              style={{
                maxWidth: dimensions,
                height: dimensions,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onClick={() => setPreviewImage(item.imageUrl)}
            >
              <img
                src={item.imageUrl}
                alt={item.title}
                style={{
                  maxWidth: `${dimensions - 16}px`,
                  maxHeight: `${dimensions - 16}px`,
                  objectFit: 'contain',
                  cursor: 'pointer',
                  borderRadius: 4,
                }}
              />
            </Box>
            <Typography
              style={{ width: '100%', textAlign: 'center', fontWeight: 'bold' }}
            >
              {item.title}
            </Typography>
          </Box>
        ))}
      </Box>
      <ImagePreview
        previewImage={previewImage}
        setPreviewImage={setPreviewImage}
      />
    </Box>
  );
};

export const TitleSubtitleCarouselWidget = ({
  wrapContent,
  title,
  content,
  defaultPadding,
  ...props
}) => {
  const classes = useStyles();
  return (
    <Box style={{ padding: defaultPadding ? 0 : '8px 16px' }}>
      <Typography variant="h6" style={{ fontWeight: 'bold', marginBottom: 16 }}>
        {title}
      </Typography>
      <Box
        className={classes.carouselContainer}
        style={{
          display: 'flex',
          overflowX: 'auto',
          flexWrap: wrapContent && 'wrap',
        }}
      >
        {content &&
          content.map((item, index) => (
            <Box
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'center',
                border: '1px solid #dddddd',
                borderRadius: 4,
                padding: 4,
                paddingLeft: 16,
                minWidth: 208,
                marginRight: index < content.length - 1 && 16,
                marginBottom: wrapContent && 16,
              }}
            >
              <Typography style={{ fontWeight: 'bold', fontSize: 18 }}>
                {item.title.split('\n').map((str) => (
                  <p style={{ margin: 0, padding: 0 }}>{str}</p>
                ))}
              </Typography>
              <Typography style={{ color: '#707070', fontSize: 16 }}>
                {item.subtitle.split('\n').map((str) => (
                  <p style={{ margin: 0, padding: 0 }}>{str}</p>
                ))}
              </Typography>
            </Box>
          ))}
      </Box>
    </Box>
  );
};

export const DescriptionWithIconButtonWidget = ({
  iconId,
  title,
  subtitle,
  iconButton,
  setDeepLink,
  handleDeeplink,
  setMessage,
  ...props
}) => {
  const handleSubmit = (deeplink, apiType, formBody = {}) => {
    apiType === 1 || !apiType
      ? setDeepLink(deeplink)
      : handleDeeplink(deeplink, apiType, formBody, {
          doneCallback: (refreshDeeplink) => setDeepLink(refreshDeeplink),
        }).then((response) => {
          if (response) {
            response.refreshDeeplink &&
              (setDeepLink || (() => {}))(response.refreshDeeplink);
            response.userMessage && setMessage(response.userMessage);
          }
        });
  };
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        width: props.defaultMargin ? '100%' : 'calc(100% - 20px)',
        margin: props.defaultMargin ? '8px 0 0 0' : 10,
        border: '1px solid #C4C4C4',
        padding: 16,
        borderRadius: 4,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          width: '100%',
        }}
      >
        {iconId && (
          <div style={{ marginRight: 16 }}>
            <DynamicIcon iconId={iconId} style={{ color: '#2e6bcf' }} />
          </div>
        )}
        <div>
          <Typography
            style={{ fontSize: 16, fontWeight: 'bold', color: '#2e6bcf' }}
          >
            {title}
          </Typography>
          <Typography
            style={{ fontSize: 14, color: '#808080', textAlign: 'left' }}
          >
            {subtitle}
          </Typography>
        </div>
      </div>
      {iconButton && (
        <div>
          <IconButton
            style={{ color: '#2e6bcf', padding: 0 }}
            onClick={
              props.onButtonClick ||
              (() => {
                handleSubmit(iconButton.deeplink, iconButton.apiType);
              })
            }
          >
            {iconButton.iconId ? (
              <DynamicIcon
                iconId={iconButton.iconId}
                style={{ color: '#2e6bcf' }}
              />
            ) : (
              <EditOutlined />
            )}
          </IconButton>
        </div>
      )}
    </div>
  );
};
